import { useState, useEffect, useRef, createContext, useContext } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { api } from "./api";
const GOOGLE_CLIENT_ID = String(process.env.REACT_APP_GOOGLE_CLIENT_ID || "").trim();
const LogoSvg = ({ color = "currentColor", width = 120, height = 43, className = "", style = {} }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="115 215 650 360"
    preserveAspectRatio="xMidYMid meet"
    className={className}
    style={{ display: "block", ...style }}
  >
    <g transform="translate(0,836) scale(0.1,-0.1)" fill={color} stroke="none">
      <path d="M2100 5614 c-47 -20 -107 -80 -119 -118 -25 -80 -36 -193 -35 -356 0 -143 4 -194 23 -280 50 -233 166 -457 318 -612 30 -32 50 -58 44 -58 -19 0 -101 20 -168 42 -94 30 -120 23 -151 -36 -76 -146 -11 -319 196 -517 l98 -94 -37 -35 c-72 -68 -73 -162 -4 -309 71 -149 212 -252 424 -309 88 -23 113 -26 308 -26 l212 -1 -5 -70 c-7 -96 3 -124 57 -160 92 -63 188 -65 304 -7 100 50 231 176 322 312 51 76 49 77 -24 10 -68 -63 -230 -182 -339 -249 -39 -25 -66 -33 -120 -38 -64 -5 -72 -4 -98 19 -51 43 -44 151 19 300 7 17 4 17 -36 3 -158 -56 -410 -72 -553 -35 -159 40 -296 142 -376 280 -45 77 -51 123 -20 140 14 7 87 9 228 4 183 -6 490 2 479 12 -2 2 -50 13 -107 24 -220 45 -444 137 -581 240 -163 123 -319 334 -291 395 15 34 67 33 147 -1 234 -100 345 -135 536 -168 107 -19 273 -35 261 -26 -4 3 -47 21 -97 39 -381 140 -667 431 -768 781 -64 223 -67 552 -6 689 57 128 117 105 219 -85 158 -298 415 -596 660 -769 194 -137 515 -291 755 -362 126 -38 258 -127 354 -238 81 -95 169 -293 172 -386 l0 -24 11 25 c17 43 2 209 -27 297 -75 224 -268 396 -545 486 -180 59 -524 219 -628 294 -190 134 -467 475 -662 812 -57 98 -81 121 -169 157 -64 27 -131 30 -181 8z" />
      <path d="M6933 5595 c-38 -19 -76 -43 -85 -52 -8 -10 -50 -76 -93 -148 -188 -315 -430 -610 -615 -749 -107 -80 -437 -235 -660 -309 -294 -99 -492 -299 -544 -550 -18 -85 -22 -237 -6 -237 6 0 10 11 10 24 0 40 40 157 81 236 100 193 238 302 496 391 255 88 465 189 653 314 141 94 217 159 339 290 160 171 256 303 366 502 74 132 113 176 153 171 48 -6 81 -74 103 -213 15 -95 6 -370 -15 -460 -41 -173 -114 -334 -205 -456 -137 -180 -371 -345 -611 -429 -36 -13 -68 -26 -73 -30 -10 -9 138 6 258 26 152 25 327 76 460 135 90 39 132 53 170 53 l50 1 -1 -46 c0 -62 -46 -137 -148 -246 -166 -176 -404 -298 -699 -358 -65 -13 -121 -26 -124 -28 -11 -11 291 -19 481 -13 189 7 210 6 227 -10 10 -9 19 -26 19 -37 0 -41 -66 -144 -140 -217 -129 -130 -260 -180 -469 -180 -132 0 -204 10 -321 44 -92 26 -87 33 -50 -69 42 -116 35 -206 -19 -235 -24 -12 -83 -13 -135 -1 -64 15 -343 210 -438 307 -51 50 -48 35 9 -44 144 -202 274 -308 420 -342 44 -10 61 -9 109 5 128 37 162 83 150 206 l-7 69 138 -7 c321 -14 561 54 710 203 97 98 162 254 144 350 -9 46 -42 98 -72 114 -18 10 -11 18 67 92 105 100 165 177 207 265 27 58 32 79 32 143 0 62 -5 84 -28 128 -25 47 -31 52 -61 52 -18 0 -53 -7 -77 -15 -44 -16 -162 -45 -181 -45 -6 0 19 31 54 68 280 297 394 743 307 1194 -21 105 -109 177 -215 178 -39 0 -68 -8 -121 -35z" />
      <path d="M4410 5284 c-491 -37 -850 -192 -850 -368 0 -160 274 -298 710 -357 124 -17 526 -17 650 0 286 39 517 116 633 212 46 38 77 96 77 144 0 155 -262 291 -671 350 -104 15 -445 26 -549 19z m563 -123 c277 -49 428 -139 385 -229 -64 -132 -509 -224 -932 -193 -338 24 -567 97 -614 194 -11 23 -11 32 3 61 40 84 232 154 511 186 139 16 513 5 647 -19z" />
    </g>
  </svg>
);

const LandingBrand = ({ compact = false }) => (
  <div style={{ display: "flex", alignItems: "center", gap: compact ? 8 : 10 }}>
    <LogoSvg
      color="#7c3aed"
      width={compact ? 60 : 72}
      height={compact ? 60 : 72}
      style={{ width: compact ? 60 : 72, height: compact ? 60 : 72 }}
    />
    <h1
      style={{
        fontSize: compact ? 30 : 34,
        lineHeight: 1,
        letterSpacing: "0.2px",
        color: "#7c3aed",
        fontWeight: 500,
        textTransform: "lowercase",
      }}
    >
      <span style={{ fontWeight: 800 }}>angel</span>
      {"fans"}
    </h1>
  </div>
);

const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

    :root {
      color-scheme: dark;
      --bg: #0a0812;
      --bg2: #0f0b1a;
      --bg3: #130f20;
      --surface: #1a1428;
      --surface2: #211a34;
      --border: #2a1f42;
      --border2: #342850;
      --text: #ede9fe;
      --text2: #c4b5fd;
      --text3: #7c5cbf;
      --accent: #8b5cf6;
      --accent2: #7c3aed;
      --accent-dim: rgba(139,92,246,0.15);
      --accent-dim2: rgba(139,92,246,0.07);
      --red: #ff4757;
      --blue: #c4b5fd;
      --purple: #a78bfa;
      --green: #34d399;
      --scrim: rgba(10,8,18,0.82);
      --soft-scrim: rgba(10,8,18,0.45);
      --r: 12px; --r2: 16px; --r3: 24px;
      --shadow: 0 4px 24px rgba(0,0,0,0.5);
      --shadow2: 0 8px 48px rgba(0,0,0,0.7);
    }

    [data-theme="light"] {
      color-scheme: light;
      --bg: #f5f3ff;
      --bg2: #ffffff;
      --bg3: #ede9fe;
      --surface: #ffffff;
      --surface2: #f5f3ff;
      --border: #ddd6fe;
      --border2: #c4b5fd;
      --text: #1e1333;
      --text2: #5b21b6;
      --text3: #7c3aed;
      --accent: #7c3aed;
      --accent2: #6d28d9;
      --accent-dim: rgba(124,58,237,0.10);
      --accent-dim2: rgba(124,58,237,0.05);
      --red: #dc2626;
      --blue: #6d28d9;
      --purple: #7c3aed;
      --green: #059669;
      --scrim: rgba(255,255,255,0.9);
      --soft-scrim: rgba(255,255,255,0.55);
      --shadow: 0 4px 24px rgba(109,40,217,0.10);
      --shadow2: 0 8px 48px rgba(109,40,217,0.15);
    }

    html { scroll-behavior: smooth; }

    body {
      font-family: 'Poppins', sans-serif;
      background: var(--bg);
      color: var(--text);
      min-height: 100vh;
      overflow-x: hidden;
      transition: background 0.3s, color 0.3s;
    }

    .syne { font-family: 'Poppins', sans-serif; }

    ::-webkit-scrollbar { width: 6px; height: 6px; }
    ::-webkit-scrollbar-track { background: var(--bg2); }
    ::-webkit-scrollbar-thumb { background: var(--border2); border-radius: 3px; }
    ::-webkit-scrollbar-thumb:hover { background: var(--text3); }

    input, textarea, select {
      font-family: 'Poppins', sans-serif;
      background: var(--surface);
      border: 1px solid var(--border);
      color: var(--text);
      border-radius: var(--r);
      padding: 10px 14px;
      outline: none;
      transition: border-color 0.2s, box-shadow 0.2s;
      width: 100%;
      font-size: 14px;
    }
    input:focus, textarea:focus {
      border-color: var(--accent);
      box-shadow: 0 0 0 3px var(--accent-dim);
    }
    input::placeholder, textarea::placeholder { color: var(--text3); }

    button { cursor: pointer; font-family: 'Poppins', sans-serif; border: none; outline: none; }

    .btn {
      display: inline-flex; align-items: center; gap: 8px;
      padding: 10px 20px; border-radius: var(--r);
      font-size: 14px; font-weight: 500;
      transition: all 0.2s;
    }
    .btn-accent {
      background: var(--accent); color: #fff;
    }
    .btn-accent:hover { background: var(--accent2); transform: translateY(-1px); box-shadow: 0 4px 16px rgba(139,92,246,0.4); }
    .btn-ghost {
      background: var(--surface); color: var(--text2);
      border: 1px solid var(--border);
    }
    .btn-ghost:hover { border-color: var(--border2); color: var(--text); background: var(--surface2); }
    .btn-danger { background: rgba(255,71,87,0.12); color: var(--red); border: 1px solid rgba(255,71,87,0.2); }
    .btn-danger:hover { background: rgba(255,71,87,0.2); }

    @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
    @keyframes slideIn { from { opacity: 0; transform: translateX(-12px); } to { opacity: 1; transform: translateX(0); } }
    @keyframes pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.5; } }
    @keyframes spin { to { transform: rotate(360deg); } }
    @keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }
    @keyframes popIn { 0% { transform: scale(0.8); opacity: 0; } 100% { transform: scale(1); opacity: 1; } }
    @keyframes bounceHeart { 0%,100% { transform: scale(1); } 50% { transform: scale(1.3); } }

    .fade-in { animation: fadeIn 0.4s ease forwards; }
    .slide-in { animation: slideIn 0.3s ease forwards; }

    .card {
      background: var(--surface);
      border: 1px solid var(--border);
      border-radius: var(--r2);
      padding: 20px;
    }

    .tag {
      display: inline-flex; align-items: center;
      padding: 3px 10px; border-radius: 20px;
      font-size: 11px; font-weight: 600; letter-spacing: 0.04em;
      text-transform: uppercase;
    }
    .tag-accent { background: var(--accent-dim); color: #c4b5fd; border: 1px solid rgba(139,92,246,0.3); }
    .tag-blue { background: rgba(59,130,246,0.12); color: var(--blue); border: 1px solid rgba(59,130,246,0.2); }
    .tag-purple { background: rgba(139,92,246,0.12); color: var(--purple); border: 1px solid rgba(139,92,246,0.2); }

    .avatar {
      border-radius: 50%; object-fit: cover;
      background: var(--surface2);
      display: flex; align-items: center; justify-content: center;
      flex-shrink: 0; font-weight: 700; color: #c4b5fd;
      font-family: 'Poppins', sans-serif;
    }

    .divider { height: 1px; background: var(--border); margin: 16px 0; }

    .tooltip {
      position: relative;
    }
    .tooltip:hover::after {
      content: attr(data-tip);
      position: absolute; bottom: calc(100% + 6px); left: 50%; transform: translateX(-50%);
      background: var(--surface2); color: var(--text); font-size: 12px;
      padding: 4px 10px; border-radius: 6px; white-space: nowrap;
      border: 1px solid var(--border); pointer-events: none; z-index: 100;
    }

    .modal-backdrop {
      position: fixed; inset: 0; background: rgba(0,0,0,0.7);
      backdrop-filter: blur(8px); z-index: 1000;
      display: flex; align-items: center; justify-content: center;
      padding: 20px;
      animation: fadeIn 0.2s ease;
    }
    .modal {
      background: var(--bg2); border: 1px solid var(--border);
      border-radius: var(--r3); padding: 32px;
      width: 100%; max-width: 480px; max-height: 90vh; overflow-y: auto;
      animation: popIn 0.25s ease;
    }
    @media (max-width: 480px) {
      .modal { padding: 24px 16px; border-radius: var(--r2); }
      .modal-backdrop { padding: 12px; align-items: flex-end; }
      .explore-view-hero { height: 140px !important; margin-bottom: -20px !important; }
      .auth-inner { padding: 0 4px !important; }
      .auth-card { padding: 18px 12px !important; }
    }

    .skeleton {
      background: linear-gradient(90deg, var(--surface) 25%, var(--surface2) 50%, var(--surface) 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite;
      border-radius: var(--r);
    }

    .notification-dot {
      position: absolute; top: -2px; right: -2px;
      width: 8px; height: 8px; border-radius: 50%;
      background: var(--accent); border: 2px solid var(--bg);
    }

    .grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
    .grid-3 { display: grid; grid-template-columns: repeat(3,1fr); gap: 16px; }
    .grid-4 { display: grid; grid-template-columns: repeat(4,1fr); gap: 16px; }

    @media (max-width: 768px) {
      .grid-2, .grid-3, .grid-4 { grid-template-columns: 1fr; }
    }

    .progress-bar {
      height: 4px; border-radius: 2px; background: var(--border);
      overflow: hidden;
    }
    .progress-bar-fill {
      height: 100%; border-radius: 2px;
      background: var(--accent);
      transition: width 0.6s ease;
    }

    /* Layout */
    .layout { display: flex; min-height: 100vh; }
    .sidebar {
      width: 260px; flex-shrink: 0;
      background: var(--bg2);
      border-right: 1px solid var(--border);
      position: sticky; top: 0; height: 100vh;
      overflow-y: auto; overflow-x: hidden;
      display: flex; flex-direction: column;
      transition: width 0.3s;
    }
    .main-content { flex: 1; min-width: 0; padding: 32px; max-width: 900px; margin: 0 auto; }

    /* Logged-in app layout with bottom nav */
    .app-shell { display: flex; flex-direction: column; min-height: 100vh; }
    .app-top-bar {
      position: sticky; top: 0; z-index: 200;
      background: var(--bg2); border-bottom: 1px solid var(--border);
      display: flex; align-items: center; justify-content: space-between;
      padding: 10px 20px; height: 56px; gap: 12px;
    }
    .app-main { flex: 1; overflow-y: auto; overflow-x: hidden; padding-bottom: 76px; }
    .bottom-nav {
      position: fixed; bottom: 0; left: 0; right: 0; z-index: 200;
      background: var(--bg2); border-top: 1px solid var(--border);
      display: flex; align-items: stretch; height: 64px;
      box-shadow: 0 -4px 24px rgba(0,0,0,0.4);
    }
    .bottom-nav-item {
      flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center;
      gap: 3px; background: none; border: none; color: var(--text3);
      font-size: 11px; font-weight: 500; font-family: 'Poppins', sans-serif;
      cursor: pointer; transition: color 0.2s, background 0.2s;
      padding: 6px 4px; position: relative;
    }
    .bottom-nav-item:hover { color: var(--text2); background: var(--accent-dim2); }
    .bottom-nav-item.active { color: var(--accent); }
    .bottom-nav-item.active::before {
      content: ''; position: absolute; top: 0; left: 20%; right: 20%;
      height: 2px; border-radius: 0 0 3px 3px;
      background: var(--accent);
    }

    @media (max-width: 900px) {
      .sidebar { width: 64px; }
      .sidebar .sidebar-label { display: none; }
      .sidebar .sidebar-logo-text { display: none; }
      .sidebar .sidebar-user-info { display: none; }
    }
    .sidebar-compact-mark { display: none; }
    .sidebar-logo-mobile { display: none; }
    .landing-header-inner { width: 100%; max-width: 1200px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; gap: 18px; padding: 12px 24px; }
    .landing-brand-wrap { display: flex; align-items: center; min-width: 0; }
    .landing-mobile-menu-button { display: none; align-items: center; justify-content: center; }
    .landing-mobile-drawer-backdrop { display: none; }
    .landing-mobile-drawer { display: none; }
    @media (min-width: 901px) {
      .sidebar-compact-mark { display: none !important; }
    }

    @media (max-width: 900px) {
      .sidebar { width: 84px; }
      .sidebar-logo-desktop { display: none !important; }
      .sidebar-logo-mobile { display: flex !important; justify-content: center; }
      .sidebar-bottom-button { justify-content: center; padding-left: 10px !important; padding-right: 10px !important; }
      .sidebar-theme-label { display: none !important; }
      .sidebar-user-card { padding: 10px 8px !important; justify-content: center; }
      .sidebar-user-logout { margin-left: 0 !important; }
      .landing-header-inner { padding: 12px 14px !important; gap: 10px; }
      .landing-header-actions { display: none !important; }
      .landing-mobile-menu-button { display: inline-flex !important; }
      .landing-mobile-drawer-backdrop { display: block; }
      .landing-mobile-drawer { display: flex; }
    }

    @media (max-width: 640px) {
      .auth-shell { padding: 24px 16px !important; }
      .auth-card { padding: 24px 18px !important; }
      .auth-logo-wrap { margin-bottom: 18px !important; }
      .auth-inner { padding: 0 8px !important; }
      .main-content { padding: 16px !important; }
      .app-top-bar { padding: 8px 12px !important; }
      .top-bar-username { display: none !important; }
      .top-bar-theme-btn { display: none !important; }
      .landing-brand-wrap svg { width: 46px !important; height: 46px !important; }
      .landing-brand-wrap h1 { font-size: 22px !important; }
    }

    @media (max-width: 380px) {
      .landing-brand-wrap svg { width: 38px !important; height: 38px !important; }
      .landing-brand-wrap h1 { font-size: 18px !important; }
    }

    @media (max-width: 900px) {
      .dashboard-header { flex-direction: column; align-items: stretch !important; gap: 12px; }
      .dashboard-header .btn { width: 100%; justify-content: center; }
      .dashboard-stats-grid { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
      .dashboard-chart-bars { overflow-x: auto; padding-bottom: 8px; }
      .dashboard-chart-bars > div { min-width: 380px; }
      .dashboard-top-post-row { align-items: flex-start !important; }
      .profile-header-row { flex-direction: column; align-items: flex-start !important; gap: 14px !important; }
      .profile-field-row { flex-direction: column; align-items: flex-start !important; gap: 8px; }
      .profile-field-value { width: 100%; justify-content: space-between; }
      .profile-pref-row { gap: 12px; }
      .explore-view-hero { height: 170px !important; margin-bottom: -28px !important; }
      .explore-view-body { padding: 0 10px !important; }
      .explore-view-top { flex-direction: column; align-items: flex-start !important; gap: 12px; }
      .explore-view-top .btn { width: 100%; justify-content: center; }
      .explore-view-stats { gap: 12px !important; padding: 14px 10px !important; }
    }

    @media (max-width: 520px) {
      .dashboard-stats-grid { grid-template-columns: 1fr !important; }
      .profile-field-value .btn { padding: 6px 10px !important; }
      .explore-view-name-row { align-items: flex-start !important; }
      .explore-view-stats { flex-direction: column; }
      .explore-view-stats > div { width: 100%; }
    }
  `}</style>
);
const Icon = ({ name, size = 18, className = "" }) => {
  const icons = {
    home: "M3 10.5L12 3l9 7.5 M5 9.5V21h14V9.5 M9 21v-6h6v6",
    sun: "M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42M12 5a7 7 0 100 14A7 7 0 0012 5z",
    moon: "M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z",
    explore: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z M12 8l3 4-3 4-3-4z",
    bell: "M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9 M13.73 21a2 2 0 01-3.46 0",
    user: "M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2 M12 11a4 4 0 100-8 4 4 0 000 8z",
    settings: "M12 15a3 3 0 100-6 3 3 0 000 6z M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z",
    heart: "M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z",
    comment: "M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z",
    share: "M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8 M16 6l-4-4-4 4 M12 2v13",
    plus: "M12 5v14M5 12h14",
    image: "M21 19a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2z M8.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3z M21 15l-5-5L5 21",
    video: "M23 7l-7 5 7 5V7z M1 5h14a1 1 0 011 1v12a1 1 0 01-1 1H1a1 1 0 01-1-1V6a1 1 0 011-1z",
    lock: "M19 11H5a2 2 0 00-2 2v7a2 2 0 002 2h14a2 2 0 002-2v-7a2 2 0 00-2-2z M7 11V7a5 5 0 0110 0v4",
    star: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z",
    trending: "M23 6l-9.5 9.5-5-5L1 18 M17 6h6v6",
    dollar: "M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6",
    chart: "M18 20V10M12 20V4M6 20v-6",
    users: "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2 M23 21v-2a4 4 0 00-3-3.87 M16 3.13a4 4 0 010 7.75",
    check: "M20 6L9 17l-5-5",
    x: "M18 6L6 18M6 6l12 12",
    arrow_right: "M5 12h14M12 5l7 7-7 7",
    upload: "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12",
    play: "M5 3l14 9-14 9V3z",
    logout: "M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9",
    crown: "M2 20h20M5 20L3 8l4.5 4L12 4l4.5 8L21 8l-2 12",
    eye: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z M12 15a3 3 0 100-6 3 3 0 000 6z",
    grid: "M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z",
    menu: "M3 12h18M3 6h18M3 18h18",
    chevron: "M6 9l6 6 6-6",
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round"
      strokeLinejoin="round" className={className}>
      {icons[name]?.split(" M").map((d, i) => (
        <path key={i} d={i === 0 ? d : "M" + d} />
      ))}
    </svg>
  );
};
// Não há mais criadores mockados — todos os dados vêm do banco de dados.

// AngelFans conta oficial — posts de propaganda sempre visíveis no feed
const ANGELFANS_OFFICIAL = {
  id: "angelfans_official",
  userId: "angelfans_official",
  username: "angelfans",
  name: "AngelFans",
  role: "official",
  avatar: null,
  avatarLetter: "AF",
  cover: "linear-gradient(135deg,#1a0a2e,#3b1f6e,#7c3aed)",
  bio: "A plataforma oficial de criadores de conteúdo premium. Conecte-se com os melhores criadores e acesse conteúdo exclusivo.",
  category: "Plataforma",
  subscribers: 0,
  monthlyPrice: 0,
  totalEarnings: 0,
  postsCount: 6,
  tags: ["Oficial", "Novidades", "Plataforma"],
  verified: true,
  isOfficial: true,
  posts: [
    {
      id: "af_promo_1",
      type: "image",
      exclusive: false,
      likes: 3241,
      comments: [],
      content: "🚀 Bem-vindo à AngelFans! Somos a plataforma brasileira de criadores de conteúdo premium. Aqui você encontra os melhores criadores com conteúdo exclusivo e de alta qualidade. Crie sua conta agora e descubra um novo mundo de entretenimento!",
      imageUrl: "https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?w=800&q=80",
      createdAt: "2026-04-30T12:00:00Z",
      liked: false,
      isPromo: true,
    },
    {
      id: "af_promo_2",
      type: "text",
      exclusive: false,
      likes: 1872,
      comments: [],
      content: "✨ Novidade AngelFans! Agora os criadores podem lançar pacotes semanais e mensais personalizados. Assine seus favoritos e ganhe acesso antecipado a todo conteúdo exclusivo. Planos a partir de R$19,90/mês! 💜",
      createdAt: "2026-04-28T10:00:00Z",
      liked: false,
      isPromo: true,
    },
    {
      id: "af_promo_3",
      type: "image",
      exclusive: false,
      likes: 2560,
      comments: [],
      content: "🌟 Criadores: monetize seu conteúdo com a AngelFans! Dashboard completo, pagamentos automáticos e suporte 24/7. Mais de R$1 milhão distribuído aos nossos criadores em 2026. Cadastre-se e comece a ganhar hoje!",
      imageUrl: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=800&q=80",
      createdAt: "2026-04-26T09:00:00Z",
      liked: false,
      isPromo: true,
    },
    {
      id: "af_promo_4",
      type: "image",
      exclusive: false,
      likes: 4103,
      comments: [],
      content: "💫 Destaque da semana: mais de 500 novos criadores se cadastraram na AngelFans! A plataforma cresce e você faz parte dessa história. Explore o catálogo e descubra talentos incríveis esperando por você.",
      imageUrl: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=800&q=80",
      createdAt: "2026-04-24T08:00:00Z",
      liked: false,
      isPromo: true,
    },
    {
      id: "af_promo_5",
      type: "text",
      exclusive: false,
      likes: 987,
      comments: [],
      content: "🔒 Sua privacidade em primeiro lugar! A AngelFans utiliza criptografia de ponta e pagamentos 100% seguros. Seus dados jamais são compartilhados. Navegue e assine com total tranquilidade. 💜 #AngelFans #Segurança",
      createdAt: "2026-04-22T15:00:00Z",
      liked: false,
      isPromo: true,
    },
  ],
};

const creatorCoverByIndex = [
  "linear-gradient(135deg,#1a1a2e,#16213e,#0f3460)",
  "linear-gradient(135deg,#0f2027,#203a43,#2c5364)",
  "linear-gradient(135deg,#2d1b69,#11998e,#38ef7d)",
  "linear-gradient(135deg,#4e4376,#2b5876,#4facfe)",
];

const reservedCreatorSlugs = new Set([
  "feed",
  "explore",
  "dashboard",
  "subscriptions",
  "profile",
  "login",
  "signup",
  "auth",
]);

const toUnifiedSlug = (value, fallback = "creator") => {
  const normalized = String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

  return normalized || fallback;
};

const toCreatorViewModel = (creator, index = 0) => ({
  id: creator.userId || creator.id,
  userId: creator.userId || creator.id,
  username: creator.username ? toUnifiedSlug(creator.username, "") : "",
  name: creator.displayName || (creator.email ? creator.email.split("@")[0] : "Criador"),
  role: "creator",
  avatar: creator.avatarUrl || null,
  avatarLetter: (creator.displayName || creator.email || "C")[0].toUpperCase(),
  cover: creator.coverUrl || creatorCoverByIndex[index % creatorCoverByIndex.length],
  bio: creator.bio || "Criador de conteúdo",
  category: "Criador",
  subscribers: 0,
  monthlyPrice: 19.9,
  totalEarnings: 0,
  postsCount: 0,
  tags: ["Premium"],
  verified: Boolean(creator.verifiedCreator),
  posts: [],
});

const getCreatorSlugFromPath = (pathname) => {
  const pathOnly = String(pathname || "/").split("?")[0].split("#")[0];
  const clean = pathOnly.replace(/^\/+|\/+$/g, "");
  if (!clean) return null;

  const slug = toUnifiedSlug(clean, "");
  if (!slug || reservedCreatorSlugs.has(slug)) return null;
  return slug;
};

const hasPublicUsername = (creator) => Boolean(String(creator?.username || "").trim());

const toGuestCreatorModel = (creator, index = 0) => {
  const username = toUnifiedSlug(
    creator?.username || creator?.name || creator?.email || `creator_${index}`,
    `creator_${index}`
  );
  const posts = Array.isArray(creator?.posts) ? creator.posts : [];
  const id = creator?.userId || creator?.id || `guest_${index}`;

  return {
    ...creator,
    id,
    userId: creator?.userId || id,
    username,
    name: creator?.name || creator?.displayName || "Criador",
    avatarLetter: (creator?.avatarLetter || creator?.name || creator?.displayName || "C")[0].toUpperCase(),
    cover: creator?.cover || creatorCoverByIndex[index % creatorCoverByIndex.length],
    posts,
    postsCount: Number(creator?.postsCount ?? posts.length ?? 0),
  };
};

const buildGuestCreatorCatalog = (realCreators) => {
  return (Array.isArray(realCreators) ? realCreators : [])
    .map((creator, index) => toGuestCreatorModel(creator, index))
    .filter(hasPublicUsername);
};

const MOCK_LANDING_CREATORS = [
  {
    id: "mock_luna",
    userId: "mock_luna",
    username: "luna_velvet",
    name: "Luna Velvet",
    avatarLetter: "L",
    cover: "linear-gradient(135deg,#1a0a2e,#3b1f6e,#7c3aed)",
    bio: "Modelo e criadora de conteúdo premium 🌙",
    category: "Modelo",
    subscribers: 1240,
    monthlyPrice: 29.9,
    verified: true,
    postsCount: 3,
    posts: [
      { id: "mock_luna_1", type: "image", exclusive: true, likes: 2341, comments: [], content: "Ensaio especial de quinta 🌙✨ Acesse pelo plano mensal e veja tudo na íntegra, amor!", imageUrl: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=800&q=80", createdAt: "2026-04-29T20:00:00Z", liked: false },
      { id: "mock_luna_2", type: "text", exclusive: false, likes: 987, comments: [], content: "Boa noite para todos vocês 💜 Hoje foi um dia incrível de gravações. Amanhã tem conteúdo novinho!", imageUrl: "", createdAt: "2026-04-27T22:00:00Z", liked: false },
    ],
  },
  {
    id: "mock_bella",
    userId: "mock_bella",
    username: "bella_noir",
    name: "Bella Noir",
    avatarLetter: "B",
    cover: "linear-gradient(135deg,#0f2027,#203a43,#2c5364)",
    bio: "Arte, sensualidade e conteúdo exclusivo 🖤",
    category: "Artista",
    subscribers: 876,
    monthlyPrice: 24.9,
    verified: true,
    postsCount: 3,
    posts: [
      { id: "mock_bella_1", type: "image", exclusive: true, likes: 1876, comments: [], content: "Novo editorial disponível apenas para assinantes 🖤 Vocês vão adorar a produção!", imageUrl: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=800&q=80", createdAt: "2026-04-29T18:00:00Z", liked: false },
      { id: "mock_bella_2", type: "text", exclusive: false, likes: 543, comments: [], content: "Obrigada pelo carinho de todos! Cada mensagem de vocês me motiva a criar mais. 🖤", imageUrl: "", createdAt: "2026-04-26T14:00:00Z", liked: false },
    ],
  },
  {
    id: "mock_carol",
    userId: "mock_carol",
    username: "carol_rose",
    name: "Carol Rose",
    avatarLetter: "C",
    cover: "linear-gradient(135deg,#2d1b69,#11998e,#38ef7d)",
    bio: "Conteúdo premium e exclusivo 🌹",
    category: "Modelo",
    subscribers: 2103,
    monthlyPrice: 19.9,
    verified: false,
    postsCount: 2,
    posts: [
      { id: "mock_carol_1", type: "image", exclusive: true, likes: 3201, comments: [], content: "Sessão de fotos especial de fim de semana 🌹 Disponível para assinantes. Me diz o que acharam!", imageUrl: "https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?w=800&q=80", createdAt: "2026-04-28T16:00:00Z", liked: false },
    ],
  },
  {
    id: "mock_valentina",
    userId: "mock_valentina",
    username: "valentina_fire",
    name: "Valentina Fire",
    avatarLetter: "V",
    cover: "linear-gradient(135deg,#4e4376,#2b5876,#4facfe)",
    bio: "Intensidade e paixão em cada conteúdo 🔥",
    category: "Criadora",
    subscribers: 3412,
    monthlyPrice: 34.9,
    verified: true,
    postsCount: 2,
    posts: [
      { id: "mock_val_1", type: "image", exclusive: true, likes: 4102, comments: [], content: "🔥 Novo conteúdo exclusivo chegando! Assinantes do plano premium têm acesso antecipado. Prepara o coração!", imageUrl: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=800&q=80", createdAt: "2026-04-30T10:00:00Z", liked: false },
      { id: "mock_val_2", type: "text", exclusive: false, likes: 1289, comments: [], content: "Domingo de gravações! 🎬 Quem tiver curiosidade do que vem por aí, dá uma olhada nas stories 😉🔥", imageUrl: "", createdAt: "2026-04-25T12:00:00Z", liked: false },
    ],
  },
];

const toPostViewModel = (post) => ({
  id: post._id || post.id,
  type: post.type || "text",
  exclusive: Boolean(post.exclusive),
  likes: Array.isArray(post.likes) ? post.likes.length : Number(post.likes || 0),
  comments: Array.isArray(post.comments) ? post.comments : [],
  content: post.content || "",
  imageUrl: post.mediaUrl || post.imageUrl || "",
  createdAt: post.createdAt || new Date().toISOString(),
  liked: false,
});

const toNotificationViewModel = (notification, index = 0) => ({
  id: notification._id || notification.id || `${Date.now()}-${index}`,
  text: notification.message || notification.text || "Notificação",
  time: notification.createdAt
    ? new Date(notification.createdAt).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })
    : "agora",
  read: Boolean(notification.read),
  avatar: (notification.title || "N")[0].toUpperCase(),
});

const friendlyError = (error, fallback = "Não foi possível concluir esta ação.") => {
  const raw = String(error?.message || error || "").trim();
  if (!raw) return fallback;
  const lowered = raw.toLowerCase();
  if (lowered.includes("failed to fetch") || lowered.includes("networkerror") || lowered.includes("load failed")) {
    return "Não foi possível conectar ao servidor. Tente novamente.";
  }
  if (lowered.includes("token inválido") || lowered.includes("sessão expirada") || lowered.includes("401")) {
    return "Sua sessão expirou. Faça login novamente.";
  }
  if (lowered.includes("403")) return "Você não tem permissão para essa ação.";
  if (lowered.includes("404")) return "Recurso não encontrado.";
  if (lowered.includes("409")) return "Este recurso já existe.";
  if (lowered.includes("500")) return "Erro interno. Tente novamente em alguns instantes.";
  return raw.replace(/^\[\d+\]\s*/, "");
};

const AppContext = createContext(null);

const useApp = () => useContext(AppContext);

const Toasts = ({ toasts, onDismiss }) => (
  <div style={{
    position: "fixed", top: 16, right: 16, zIndex: 2000,
    display: "flex", flexDirection: "column", gap: 12,
  }}>
    {toasts.map(t => (
      <div key={t.id} style={{
        minWidth: 280, maxWidth: 380,
        background: "linear-gradient(135deg, var(--surface) 0%, var(--surface2) 100%)",
        border: "1px solid var(--border)",
        borderRadius: "var(--r2)",
        boxShadow: "var(--shadow2)",
        padding: "12px 14px 12px 12px",
        display: "flex", gap: 12, alignItems: "flex-start",
        position: "relative", overflow: "hidden",
        animation: "popIn 0.2s ease",
      }}>
        <div style={{
          position: "absolute", left: 0, top: 0, bottom: 0, width: 4,
          background: t.type === "error" ? "var(--red)" : "var(--accent)",
        }} />
        <div style={{
          width: 34, height: 34, borderRadius: 10,
          background: "linear-gradient(135deg,#8b5cf6,#6d28d9)",
          display: "grid", placeItems: "center",
          color: "#fff", fontWeight: 700, fontSize: 11, letterSpacing: "0.08em",
          flexShrink: 0,
        }}>
          AF
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text)" }}>
            {t.title || "AngelFans"}
          </div>
          <div style={{ fontSize: 12, color: "var(--text2)", marginTop: 2 }}>
            {t.message}
          </div>
        </div>
        <button onClick={() => onDismiss(t.id)} style={{ background: "none", color: "var(--text3)" }}>
          <Icon name="x" size={14} />
        </button>
      </div>
    ))}
  </div>
);
const AVATAR_COLORS = [
  "#ef4444", "#f97316", "#eab308", "#22c55e", "#06b6d4",
  "#3b82f6", "#6366f1", "#a855f7", "#ec4899", "#14b8a6",
];

const pickAvatarColor = (seedText = "") => {
  let hash = 0;
  for (let i = 0; i < seedText.length; i += 1) {
    hash = (hash * 31 + seedText.charCodeAt(i)) >>> 0;
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
};

const Avatar = ({ letter, src = null, alt = "", size = 40, color = "#a78bfa" }) => {
  const initial = String(letter || alt || "?").trim().charAt(0).toUpperCase();
  const seed = String(alt || letter || src || "avatar");
  const bg = pickAvatarColor(seed);

  return (
    <div className="avatar" style={{
      width: size,
      height: size,
      fontSize: size * 0.42,
      color: "#ffffff",
      background: bg,
      border: `2px solid ${bg}55`,
      boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
      flexShrink: 0,
      fontWeight: 800,
      lineHeight: 1,
      letterSpacing: "0.01em",
      textTransform: "uppercase",
    }}>
      {initial || String(color || "").charAt(0).toUpperCase()}
    </div>
  );
};

const NotificationsPanel = ({ onClose }) => {
  const { notifications, markAllRead } = useApp();
  return (
    <div style={{
      position: "absolute", top: "calc(100% + 12px)", right: 0,
      width: 340, background: "var(--bg2)", border: "1px solid var(--border)",
      borderRadius: "var(--r2)", boxShadow: "var(--shadow2)",
      animation: "popIn 0.2s ease", zIndex: 200,
      overflow: "hidden",
    }}>
      <div style={{ padding: "16px 20px", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span className="syne" style={{ fontWeight: 600 }}>Notificações</span>
        <button onClick={markAllRead} style={{ background: "none", color: "var(--accent)", fontSize: 12, fontWeight: 500 }}>
          Marcar todas como lidas
        </button>
      </div>
      <div style={{ maxHeight: 320, overflowY: "auto" }}>
        {notifications.map(n => (
          <div key={n.id} style={{
            padding: "14px 20px", display: "flex", gap: 12, alignItems: "flex-start",
            borderBottom: "1px solid var(--border)", cursor: "pointer",
            background: n.read ? "transparent" : "var(--accent-dim2)",
            transition: "background 0.2s",
          }}>
            <Avatar letter={n.avatar} size={36} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ fontSize: 13, color: "var(--text)", lineHeight: 1.5 }}>{n.text}</p>
              <span style={{ fontSize: 11, color: "var(--text3)", marginTop: 4, display: "block" }}>{n.time} atrás</span>
            </div>
            {!n.read && (
              <div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--accent)", flexShrink: 0, marginTop: 4 }} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const GuestSidebar = ({ onLogin, onExplore, theme, toggleTheme }) => {
  const navItems = [
    { key: "explore", icon: "explore", label: "Explorar" },
    { key: "login", icon: "user", label: "Entrar" },
  ];
  const handleNav = (key) => {
    if (key === "login") onLogin();
    else onExplore();
  };
  return (
    <aside className="sidebar">
      {/* Logo */}
      <div style={{ padding: "20px 16px 16px", borderBottom: "1px solid var(--border)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div className="sidebar-label sidebar-logo-desktop" style={{ display: "flex", justifyContent: "center" }}>
            <LogoSvg color="var(--text)" width={150} height={53} style={{ width: "100%", maxWidth: 150, height: "auto" }} />
          </div>
          <div className="sidebar-logo-mobile">
            <LogoSvg color="var(--text)" width={44} height={44} style={{ width: 44, height: 44 }} />
          </div>
          <div className="sidebar-compact-mark" style={{
            width: 6, height: 32, borderRadius: 3,
            background: "linear-gradient(180deg, #a78bfa, #6d28d9)",
            boxShadow: "0 0 10px rgba(139,92,246,0.5)",
          }} />
        </div>
      </div>

      {/* Nav */}
      <nav style={{ padding: "16px 12px", flex: 1 }}>
        {navItems.map(item => (
          <button key={item.key} onClick={() => handleNav(item.key)}
            style={{
              width: "100%", display: "flex", alignItems: "center", gap: 12,
              padding: "10px 12px", borderRadius: "var(--r)",
              background: "transparent",
              color: item.key === "login" ? "var(--accent)" : "var(--text2)",
              border: item.key === "login" ? "1px solid rgba(139,92,246,0.25)" : "1px solid transparent",
              marginBottom: 4, transition: "all 0.2s", textAlign: "left",
              fontWeight: item.key === "login" ? 600 : 400, fontSize: 14,
            }}>
            <Icon name={item.icon} size={18} />
            <span className="sidebar-label">{item.label}</span>
          </button>
        ))}
      </nav>

      {/* Bottom */}
      <div style={{ padding: "12px", borderTop: "1px solid var(--border)" }}>
        {/* Theme Toggle */}
        <button onClick={toggleTheme} className="tooltip sidebar-bottom-button" data-tip={theme === "dark" ? "Claro" : "Escuro"}
          style={{
            width: "100%", display: "flex", alignItems: "center", gap: 12,
            padding: "10px 12px", borderRadius: "var(--r)",
            background: "transparent", color: "var(--text2)", border: "1px solid transparent",
            transition: "all 0.2s", fontSize: 14, marginBottom: 8,
          }}>
          <div style={{
            width: 36, height: 20, borderRadius: 10, position: "relative",
            background: theme === "dark" ? "linear-gradient(135deg,#8b5cf6,#6d28d9)" : "linear-gradient(135deg,#fbbf24,#f59e0b)",
            transition: "background 0.3s", flexShrink: 0,
          }}>
            <div style={{
              position: "absolute", top: 3, width: 14, height: 14, borderRadius: "50%",
              background: "#fff", transition: "left 0.3s",
              left: theme === "dark" ? 19 : 3,
            }} />
          </div>
          <span className="sidebar-label sidebar-theme-label" style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <Icon name={theme === "dark" ? "moon" : "sun"} size={14} />
            {theme === "dark" ? "Modo Escuro" : "Modo Claro"}
          </span>
        </button>
        {/* Guest card */}
        <div style={{
          padding: "10px 12px", borderRadius: "var(--r)",
          background: "var(--accent-dim)", border: "1px solid rgba(139,92,246,0.2)",
        }}>
          <div className="sidebar-label" style={{ fontSize: 12, color: "var(--text2)", marginBottom: 6, lineHeight: 1.4 }}>
            Entre para assinar e desbloquear conteúdo exclusivo.
          </div>
          <button onClick={onLogin} className="btn btn-accent" style={{ width: "100%", fontSize: 13, padding: "7px 10px" }}>
            <Icon name="user" size={13} /> <span className="sidebar-label">Criar conta</span>
          </button>
        </div>
      </div>
    </aside>
  );
};

// eslint-disable-next-line no-unused-vars
const Sidebar = ({ page, setPage, theme, toggleTheme }) => {
  const { currentUser, logout, notifications } = useApp();
  const [showNotif, setShowNotif] = useState(false);
  const unread = notifications.filter(n => !n.read).length;
  const notifRef = useRef(null);

  const navItems = currentUser?.role === "creator"
    ? [
        { key: "feed", icon: "home", label: "Feed" },
        { key: "explore", icon: "explore", label: "Explorar" },
        { key: "dashboard", icon: "chart", label: "Dashboard" },
        { key: "profile", icon: "user", label: "Meu Perfil" },
      ]
    : [
        { key: "feed", icon: "home", label: "Feed" },
        { key: "explore", icon: "explore", label: "Explorar" },
        { key: "subscriptions", icon: "star", label: "Assinaturas" },
        { key: "profile", icon: "user", label: "Perfil" },
      ];

  useEffect(() => {
    const handle = e => {
      if (notifRef.current && !notifRef.current.contains(e.target)) setShowNotif(false);
    };
    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, []);

  return (
    <aside className="sidebar">
      {/* Logo */}
      <div style={{ padding: "20px 16px 16px", borderBottom: "1px solid var(--border)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div className="sidebar-label sidebar-logo-desktop" style={{ display: "flex", justifyContent: "center" }}>
            <LogoSvg color="var(--text)" width={150} height={53} style={{ width: "100%", maxWidth: 150, height: "auto" }} />
          </div>
          <div className="sidebar-logo-mobile">
            <LogoSvg color="var(--text)" width={44} height={44} style={{ width: 44, height: 44 }} />
          </div>
          {/* Accent bar shown only when sidebar is collapsed */}
          <div className="sidebar-compact-mark" style={{
            width: 6, height: 32, borderRadius: 3,
            background: "linear-gradient(180deg, #a78bfa, #6d28d9)",
            boxShadow: "0 0 10px rgba(139,92,246,0.5)",
          }} />
        </div>
      </div>

      {/* Nav */}
      <nav style={{ padding: "16px 12px", flex: 1 }}>
        {navItems.map(item => (
          <button key={item.key} onClick={() => setPage(item.key)}
            style={{
              width: "100%", display: "flex", alignItems: "center", gap: 12,
              padding: "10px 12px", borderRadius: "var(--r)",
              background: page === item.key ? "var(--accent-dim)" : "transparent",
              color: page === item.key ? "var(--accent)" : "var(--text2)",
              border: page === item.key ? "1px solid rgba(139,92,246,0.25)" : "1px solid transparent",
              marginBottom: 4, transition: "all 0.2s", textAlign: "left",
              fontWeight: page === item.key ? 600 : 400, fontSize: 14,
            }}>
            <Icon name={item.icon} size={18} />
            <span className="sidebar-label">{item.label}</span>
          </button>
        ))}
      </nav>

      {/* Bottom */}
      <div style={{ padding: "12px", borderTop: "1px solid var(--border)" }}>
        {/* Theme Toggle */}
        <button
          onClick={toggleTheme}
          className="tooltip sidebar-bottom-button"
          data-tip={theme === "dark" ? "Claro" : "Escuro"}
          style={{
            width: "100%", display: "flex", alignItems: "center", gap: 12,
            padding: "10px 12px", borderRadius: "var(--r)",
            background: "transparent",
            color: "var(--text2)", border: "1px solid transparent",
            transition: "all 0.2s", fontSize: 14, marginBottom: 8,
          }}>
          <div style={{
            width: 36, height: 20, borderRadius: 10, position: "relative",
            background: theme === "dark"
              ? "linear-gradient(135deg,#8b5cf6,#6d28d9)"
              : "linear-gradient(135deg,#fbbf24,#f59e0b)",
            transition: "background 0.3s", flexShrink: 0,
          }}>
            <div style={{
              position: "absolute", top: 3, width: 14, height: 14, borderRadius: "50%",
              background: "#fff", transition: "left 0.3s",
              left: theme === "dark" ? 19 : 3,
            }} />
          </div>
          <span className="sidebar-label sidebar-theme-label" style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <Icon name={theme === "dark" ? "moon" : "sun"} size={14} />
            {theme === "dark" ? "Modo Escuro" : "Modo Claro"}
          </span>
        </button>
        {/* Notifications */}
        <div ref={notifRef} style={{ position: "relative", marginBottom: 8 }}>
          <button onClick={() => setShowNotif(!showNotif)} className="sidebar-bottom-button"
            style={{
              width: "100%", display: "flex", alignItems: "center", gap: 12,
              padding: "10px 12px", borderRadius: "var(--r)",
              background: showNotif ? "var(--surface2)" : "transparent",
              color: "var(--text2)", border: "1px solid transparent",
              transition: "all 0.2s", fontSize: 14, position: "relative",
            }}>
            <div style={{ position: "relative" }}>
              <Icon name="bell" size={18} />
              {unread > 0 && <div className="notification-dot" />}
            </div>
            <span className="sidebar-label">Notificações {unread > 0 && `(${unread})`}</span>
          </button>
          {showNotif && <NotificationsPanel onClose={() => setShowNotif(false)} />}
        </div>

        {/* User */}
        {currentUser && (
          <div style={{
            display: "flex", alignItems: "center", gap: 10,
            padding: "10px 12px", borderRadius: "var(--r)",
            background: "var(--surface)", border: "1px solid var(--border)",
          }} className="sidebar-user-card">
            <Avatar letter={currentUser.name[0]} src={currentUser.avatar} alt={currentUser.name} size={32} />
            <div className="sidebar-user-info" style={{ flex: 1, minWidth: 0 }}>
              <p style={{ fontSize: 13, fontWeight: 600, color: "var(--text)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {currentUser.name}
              </p>
              <p style={{ fontSize: 11, color: "var(--text3)" }}>
                {currentUser.role === "creator" ? "Criador" : "Assinante"}
              </p>
            </div>
            <button onClick={logout} className="tooltip sidebar-user-logout" data-tip="Sair"
              style={{ background: "none", color: "var(--text3)", padding: 4, borderRadius: 6, flexShrink: 0 }}>
              <Icon name="logout" size={16} />
            </button>
          </div>
        )}
      </div>
    </aside>
  );
};

const TopBar = ({ theme, toggleTheme, setPage }) => {
  const { currentUser, logout, notifications } = useApp();
  const [showNotif, setShowNotif] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const notifRef = useRef(null);
  const userMenuRef = useRef(null);
  const unread = notifications.filter(n => !n.read).length;

  useEffect(() => {
    const handle = e => {
      if (notifRef.current && !notifRef.current.contains(e.target)) setShowNotif(false);
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) setShowUserMenu(false);
    };
    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, []);

  return (
    <header className="app-top-bar">
      <LogoSvg color="var(--accent)" width={110} height={38} style={{ flexShrink: 0 }} />
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginLeft: "auto" }}>
        {/* Notifications */}
        <div ref={notifRef} style={{ position: "relative" }}>
          <button onClick={() => setShowNotif(v => !v)} className="tooltip" data-tip="Notificações"
            style={{
              background: showNotif ? "var(--surface2)" : "var(--surface)",
              border: "1px solid var(--border)",
              color: "var(--text2)", padding: "6px 10px", borderRadius: "var(--r)",
              display: "flex", alignItems: "center", gap: 6, position: "relative",
            }}>
            <div style={{ position: "relative" }}>
              <Icon name="bell" size={16} />
              {unread > 0 && <div className="notification-dot" />}
            </div>
            {unread > 0 && <span style={{ fontSize: 12, color: "var(--accent)", fontWeight: 600 }}>{unread}</span>}
          </button>
          {showNotif && <NotificationsPanel onClose={() => setShowNotif(false)} />}
        </div>
        {/* User avatar — clicável abre dropdown com perfil e sair */}
        {currentUser && (
          <div ref={userMenuRef} style={{ position: "relative" }}>
            <button
              onClick={() => setShowUserMenu(v => !v)}
              style={{
                display: "flex", alignItems: "center", gap: 8,
                background: showUserMenu ? "var(--surface2)" : "var(--surface)",
                border: "1px solid var(--border)",
                borderRadius: "var(--r)", padding: "5px 10px", cursor: "pointer",
              }}>
              <Avatar letter={currentUser.name[0]} src={currentUser.avatar} alt={currentUser.name} size={26} />
              <span className="top-bar-username" style={{ fontSize: 13, fontWeight: 600, color: "var(--text)", maxWidth: 120,
                whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {currentUser.name}
              </span>
              <Icon name="chevron" size={13} style={{ color: "var(--text3)", transform: showUserMenu ? "rotate(180deg)" : "none", transition: "transform 0.2s" }} />
            </button>
            {showUserMenu && (
              <div style={{
                position: "absolute", right: 0, top: "calc(100% + 6px)",
                background: "var(--surface)", border: "1px solid var(--border)",
                borderRadius: "var(--r2)", padding: "6px",
                minWidth: 170, boxShadow: "var(--shadow2)", zIndex: 300,
              }}>
                <button
                  onClick={() => { setPage("profile"); setShowUserMenu(false); }}
                  style={{
                    width: "100%", display: "flex", alignItems: "center", gap: 10,
                    padding: "9px 12px", borderRadius: "var(--r)",
                    background: "none", color: "var(--text)", fontSize: 13, fontWeight: 500,
                    transition: "background 0.15s",
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = "var(--surface2)"}
                  onMouseLeave={e => e.currentTarget.style.background = "none"}
                >
                  <Icon name="user" size={15} /> Meu Perfil
                </button>
                <button
                  onClick={() => { toggleTheme(); }}
                  style={{
                    width: "100%", display: "flex", alignItems: "center", gap: 10,
                    padding: "9px 12px", borderRadius: "var(--r)",
                    background: "none", color: "var(--text2)", fontSize: 13, fontWeight: 500,
                    transition: "background 0.15s",
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = "var(--surface2)"}
                  onMouseLeave={e => e.currentTarget.style.background = "none"}
                >
                  <Icon name={theme === "dark" ? "sun" : "moon"} size={15} />
                  {theme === "dark" ? "Modo Claro" : "Modo Escuro"}
                </button>
                <div style={{ height: 1, background: "var(--border)", margin: "4px 0" }} />
                <button
                  onClick={() => { logout(); setShowUserMenu(false); }}
                  style={{
                    width: "100%", display: "flex", alignItems: "center", gap: 10,
                    padding: "9px 12px", borderRadius: "var(--r)",
                    background: "none", color: "var(--red)", fontSize: 13, fontWeight: 500,
                    transition: "background 0.15s",
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = "rgba(255,71,87,0.08)"}
                  onMouseLeave={e => e.currentTarget.style.background = "none"}
                >
                  <Icon name="logout" size={15} /> Sair da conta
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

const BottomNav = ({ page, setPage }) => {
  const { currentUser } = useApp();

  const navItems = currentUser?.role === "creator"
    ? [
        { key: "feed", icon: "home", label: "Feed" },
        { key: "explore", icon: "explore", label: "Explorar" },
        { key: "dashboard", icon: "chart", label: "Dashboard" },
        { key: "profile", icon: "user", label: "Perfil" },
      ]
    : [
        { key: "feed", icon: "home", label: "Feed" },
        { key: "explore", icon: "explore", label: "Explorar" },
        { key: "subscriptions", icon: "star", label: "Assinaturas" },
        { key: "profile", icon: "user", label: "Perfil" },
      ];

  return (
    <nav className="bottom-nav">
      {navItems.map(item => (
        <button
          key={item.key}
          className={`bottom-nav-item${page === item.key ? " active" : ""}`}
          onClick={() => setPage(item.key)}
        >
          <Icon name={item.icon} size={22} />
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

const PostCard = ({ post, creator, isSubscribed }) => {
  const { currentUser, toggleLike, addComment } = useApp();
  const [showComments, setShowComments] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [localPost, setLocalPost] = useState(post);
  const [heartAnim, setHeartAnim] = useState(false);
  const [comments, setComments] = useState(Array.isArray(post.comments) ? post.comments : []);

  useEffect(() => {
    setLocalPost(post);
    setComments(Array.isArray(post.comments) ? post.comments : []);
  }, [post]);

  const isBlurred = post.exclusive && !isSubscribed;
  const isLocked = post.exclusive && !isSubscribed;
  const lockedMessage = currentUser
    ? "Assine este criador para liberar este post."
    : "Entre e assine este criador para liberar este post.";

  const handleLike = async () => {
    setHeartAnim(true);
    setTimeout(() => setHeartAnim(false), 400);
    try {
      const result = await toggleLike(post.id);
      setLocalPost((p) => ({ ...p, liked: result?.liked ?? !p.liked, likes: result?.likes ?? p.likes }));
    } catch {
      setLocalPost((p) => ({ ...p, liked: !p.liked, likes: p.liked ? p.likes - 1 : p.likes + 1 }));
    }
  };

  const handleComment = async () => {
    if (!commentText.trim()) return;
    try {
      await addComment(post.id, commentText);
    } catch {}
    setComments((c) => [...c, { id: Date.now(), userId: currentUser.id, text: commentText, createdAt: new Date().toISOString() }]);
    setCommentText("");
  };

  const typeColors = { image: "var(--purple)", video: "var(--blue)", text: "var(--green)" };
  const typeIcons = { image: "image", video: "play", text: "comment" };

  return (
    <div className="card fade-in" style={{ marginBottom: 20, overflow: "hidden", padding: 0 }}>
      <div style={{ padding: "16px 20px 12px", display: "flex", alignItems: "center", gap: 12 }}>
        <Avatar letter={creator.avatarLetter} src={creator.avatar} alt={creator.name} size={40} />
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ fontWeight: 600, fontSize: 14 }}>{creator.name}</span>
            {creator.verified && (
              <div style={{ width: 16, height: 16, borderRadius: "50%", background: "linear-gradient(135deg,#8b5cf6,#6d28d9)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Icon name="check" size={10} />
              </div>
            )}
          </div>
          <span style={{ fontSize: 12, color: "var(--text3)" }}>
            {new Date(post.createdAt).toLocaleDateString("pt-BR", { day: "numeric", month: "short" })}
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {post.exclusive && (
            <span className="tag tag-accent"><Icon name="lock" size={10} /> Exclusivo</span>
          )}
          <span className="tag" style={{ background: `${typeColors[post.type]}18`, color: typeColors[post.type], border: `1px solid ${typeColors[post.type]}30` }}>
            <Icon name={typeIcons[post.type]} size={10} /> {post.type}
          </span>
        </div>
      </div>

      <div style={{ padding: "0 20px 16px" }}>
        {isLocked ? (
          <div style={{
            padding: "16px 18px",
            borderRadius: "var(--r)",
            background: "var(--accent-dim2)",
            border: "1px solid rgba(139,92,246,0.18)",
            display: "flex",
            alignItems: "center",
            gap: 10,
            color: "var(--text2)",
          }}>
            <Icon name="lock" size={16} />
            <span style={{ fontSize: 14, lineHeight: 1.5 }}>{lockedMessage}</span>
          </div>
        ) : (
          <p style={{ fontSize: 14, lineHeight: 1.6, color: "var(--text2)" }}>{post.content}</p>
        )}
      </div>

      {post.imageUrl && (
        <div style={{ position: "relative", overflow: "hidden", maxHeight: 400 }}>
          <img
            src={post.imageUrl}
            alt=""
            style={{
              width: "100%", objectFit: "cover",
              filter: isBlurred ? "blur(20px)" : "none",
              transform: isBlurred ? "scale(1.1)" : "none",
              transition: "filter 0.3s",
              display: "block",
            }}
          />
          {isLocked && (
            <div style={{
              position: "absolute",
              inset: 0,
              background: "rgba(10,8,18,0.42)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <div style={{
                padding: "10px 14px",
                borderRadius: 999,
                background: "rgba(10,8,18,0.78)",
                border: "1px solid rgba(139,92,246,0.28)",
                color: "var(--text)",
                display: "flex",
                alignItems: "center",
                gap: 8,
                fontSize: 13,
                fontWeight: 600,
              }}>
                <Icon name="lock" size={14} /> Conteúdo para assinantes
              </div>
            </div>
          )}
        </div>
      )}

      <div style={{ padding: "12px 20px", display: "flex", alignItems: "center", gap: 4, borderTop: "1px solid var(--border)" }}>
        <button onClick={handleLike}
          disabled={!currentUser || isLocked}
          style={{
            display: "flex", alignItems: "center", gap: 6, padding: "7px 12px",
            borderRadius: "var(--r)", background: "transparent", border: "none",
            color: localPost.liked ? "#ff4757" : "var(--text3)",
            transition: "all 0.2s", fontSize: 13,
            animation: heartAnim ? "bounceHeart 0.4s ease" : "none",
            opacity: !currentUser || isLocked ? 0.55 : 1,
          }}>
          <Icon name="heart" size={16} />
          <span>{localPost.likes}</span>
        </button>
        <button onClick={() => setShowComments(!showComments)}
          disabled={!currentUser || isLocked}
          style={{
            display: "flex", alignItems: "center", gap: 6, padding: "7px 12px",
            borderRadius: "var(--r)", background: "transparent", border: "none",
            color: showComments ? "var(--accent)" : "var(--text3)",
            transition: "all 0.2s", fontSize: 13,
            opacity: !currentUser || isLocked ? 0.55 : 1,
          }}>
          <Icon name="comment" size={16} />
          <span>{comments.length}</span>
        </button>
        <div style={{ flex: 1 }} />
        <button style={{
          display: "flex", alignItems: "center", gap: 6, padding: "7px 12px",
          borderRadius: "var(--r)", background: "transparent", border: "none",
          color: "var(--text3)", fontSize: 13,
        }}>
          <Icon name="share" size={16} />
        </button>
      </div>

      {showComments && currentUser && !isLocked && (
        <div style={{ padding: "0 20px 16px", borderTop: "1px solid var(--border)" }}>
          <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 10 }}>
            {comments.map((c, idx) => (
              <div key={c.id || `${c.userId || "u"}-${idx}`} style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                <Avatar letter={(c.user || c.userId || "Usuário")[0].toUpperCase()} size={28} />
                <div style={{ background: "var(--bg2)", borderRadius: "var(--r)", padding: "8px 12px", flex: 1 }}>
                  <span style={{ fontSize: 12, fontWeight: 600, color: "var(--accent)" }}>{c.user || c.userId || "Usuário"}</span>
                  <p style={{ fontSize: 13, color: "var(--text2)", marginTop: 2 }}>{c.text}</p>
                </div>
                <span style={{ fontSize: 11, color: "var(--text3)", whiteSpace: "nowrap", marginTop: 8 }}>
                  {c.time || (c.createdAt ? new Date(c.createdAt).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }) : "agora")}
                </span>
              </div>
            ))}
          </div>
          <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
            <input
              value={commentText}
              onChange={e => setCommentText(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleComment()}
              placeholder="Adicionar comentário..."
              style={{ flex: 1 }}
            />
            <button onClick={handleComment} className="btn btn-accent" style={{ padding: "10px 16px", flexShrink: 0 }}>
              <Icon name="arrow_right" size={16} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const CreatorCard = ({ creator, onView, onSubscribe, isSubscribed }) => (
  <div className="card fade-in" style={{ padding: 0, overflow: "hidden", cursor: "pointer" }}
    onClick={() => onView(creator)}>
    <div style={{
      height: 100, background: creator.cover,
      position: "relative",
    }}>
      <div style={{
        position: "absolute", bottom: -24, left: 20,
        width: 48, height: 48,
        border: "3px solid var(--surface)",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}>
        <Avatar letter={creator.avatarLetter} src={creator.avatar} alt={creator.name} size={48} />
      </div>
      {creator.verified && (
        <div style={{
          position: "absolute", top: 12, right: 12,
          background: "linear-gradient(135deg,#8b5cf6,#6d28d9)", borderRadius: 20, padding: "2px 8px",
          fontSize: 11, fontWeight: 600, color: "#fff", display: "flex", alignItems: "center", gap: 4,
        }}>
          <Icon name="check" size={10} /> Verificado
        </div>
      )}
    </div>
    <div style={{ padding: "32px 20px 20px" }}>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 8 }}>
        <div>
          <h3 className="syne" style={{ fontSize: 15, fontWeight: 700 }}>{creator.name}</h3>
          <span style={{ fontSize: 12, color: "var(--text3)" }}>@{creator.username}</span>
        </div>
        <span className="tag tag-blue">{creator.category}</span>
      </div>
      <p style={{ fontSize: 13, color: "var(--text2)", lineHeight: 1.5, marginBottom: 16, height: 56, overflow: "hidden" }}>
        {creator.bio}
      </p>
      <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
        <div style={{ textAlign: "center" }}>
          <p className="syne" style={{ fontSize: 16, fontWeight: 700, color: "var(--accent)" }}>
            {(creator.subscribers / 1000).toFixed(1)}k
          </p>
          <p style={{ fontSize: 11, color: "var(--text3)" }}>Assinantes</p>
        </div>
        <div style={{ textAlign: "center" }}>
          <p className="syne" style={{ fontSize: 16, fontWeight: 700 }}>{creator.postsCount}</p>
          <p style={{ fontSize: 11, color: "var(--text3)" }}>Posts</p>
        </div>
        <div style={{ textAlign: "center" }}>
          <p className="syne" style={{ fontSize: 16, fontWeight: 700, color: "var(--green)" }}>
            R${creator.monthlyPrice.toFixed(0)}
          </p>
          <p style={{ fontSize: 11, color: "var(--text3)" }}>/mês</p>
        </div>
      </div>
      <button
        className={`btn ${isSubscribed ? "btn-ghost" : "btn-accent"}`}
        style={{ width: "100%" }}
        onClick={e => { e.stopPropagation(); onSubscribe(creator); }}>
        {isSubscribed ? <><Icon name="check" size={14} /> Assinando</> : <><Icon name="crown" size={14} /> Assinar</>}
      </button>
    </div>
  </div>
);
const PaymentModal = ({ creator, onClose, onSuccess }) => {
  const [step, setStep] = useState(1);
  const [method, setMethod] = useState("card");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [card, setCard] = useState({ number: "", name: "", expiry: "", cvv: "" });
  const pixCodeRef = useRef(
    `00020126360014BR.GOV.BCB.PIX0114+5511999999995204000053039865802BR5911AngelFans6009SAO PAULO62070503***${Math.floor(Math.random() * 1000000).toString().padStart(6, "0")}6304AF01`
  );
  const boletoRef = useRef({
    code: "34191.79001 01043.510047 91020.150008 7 86790000001990",
    dueDate: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toLocaleDateString("pt-BR"),
  });

  const handlePay = async () => {
    setLoading(true);
    setError("");
    try {
      const ok = await onSuccess?.(method);
      if (ok === false) {
        setError("Não foi possível confirmar o pagamento. Tente novamente.");
        return;
      }
      setStep(3);
      setTimeout(() => { onClose(); }, 1500);
    } catch (e) {
      setError(friendlyError(e, "Não foi possível confirmar o pagamento."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        {step === 1 && (
          <>
            <div style={{ textAlign: "center", marginBottom: 24 }}>
              <div style={{
                width: 64, height: 64, borderRadius: "50%",
                background: "var(--accent-dim)", border: "1px solid rgba(139,92,246,0.3)",
                display: "flex", alignItems: "center", justifyContent: "center",
                margin: "0 auto 16px",
              }}>
                <Icon name="crown" size={28} />
              </div>
              <h2 className="syne" style={{ fontSize: 22, fontWeight: 700 }}>Assinar {creator.name}</h2>
              <p style={{ color: "var(--text2)", marginTop: 8 }}>Acesso completo a todo conteúdo exclusivo</p>
            </div>
            <div className="card" style={{ marginBottom: 20, background: "var(--bg)" }}>
              {["Todos os posts exclusivos", "Downloads e recursos", "Comentários e interações", "Suporte direto ao criador"].map(b => (
                <div key={b} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10, fontSize: 14 }}>
                  <div style={{ width: 20, height: 20, borderRadius: "50%", background: "var(--accent-dim)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Icon name="check" size={12} />
                  </div>
                  <span style={{ color: "var(--text2)" }}>{b}</span>
                </div>
              ))}
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20, padding: "16px 20px", background: "var(--accent-dim)", borderRadius: "var(--r)", border: "1px solid rgba(139,92,246,0.25)" }}>
              <span className="syne" style={{ fontWeight: 600 }}>Total por mês</span>
              <span className="syne" style={{ fontSize: 24, fontWeight: 800, color: "var(--accent)" }}>R$ {creator.monthlyPrice.toFixed(2)}</span>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button className="btn btn-ghost" style={{ flex: 1 }} onClick={onClose}>Cancelar</button>
              <button className="btn btn-accent" style={{ flex: 2 }} onClick={() => setStep(2)}>
                <Icon name="dollar" size={16} /> Continuar para pagamento
              </button>
            </div>
          </>
        )}

        {step === 2 && (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
              <button onClick={() => setStep(1)} style={{ background: "var(--surface)", border: "1px solid var(--border)", color: "var(--text2)", padding: "6px 10px", borderRadius: "var(--r)" }}>
                ←</button>
              <h2 className="syne" style={{ fontSize: 18, fontWeight: 700 }}>Dados de Pagamento</h2>
            </div>
            <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
              {[{ id: "card", label: "Cartão" }, { id: "pix", label: "PIX" }, { id: "boleto", label: "Boleto" }].map((m) => (
                <button
                  key={m.id}
                  onClick={() => { setMethod(m.id); setError(""); }}
                  className={`btn ${method === m.id ? "btn-accent" : "btn-ghost"}`}
                  style={{ flex: 1, fontSize: 13 }}>
                  {m.label}
                </button>
              ))}
            </div>
            {method === "card" && (
              <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 20 }}>
                <div>
                  <label style={{ fontSize: 12, color: "var(--text3)", marginBottom: 6, display: "block" }}>Número do Cartão</label>
                  <input value={card.number} onChange={e => setCard({ ...card, number: e.target.value })} placeholder="0000 0000 0000 0000" />
                </div>
                <div>
                  <label style={{ fontSize: 12, color: "var(--text3)", marginBottom: 6, display: "block" }}>Nome no Cartão</label>
                  <input value={card.name} onChange={e => setCard({ ...card, name: e.target.value })} placeholder="NOME SOBRENOME" />
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                  <div>
                    <label style={{ fontSize: 12, color: "var(--text3)", marginBottom: 6, display: "block" }}>Validade</label>
                    <input value={card.expiry} onChange={e => setCard({ ...card, expiry: e.target.value })} placeholder="MM/AA" />
                  </div>
                  <div>
                    <label style={{ fontSize: 12, color: "var(--text3)", marginBottom: 6, display: "block" }}>CVV</label>
                    <input value={card.cvv} onChange={e => setCard({ ...card, cvv: e.target.value })} placeholder="000" />
                  </div>
                </div>
              </div>
            )}

            {method === "pix" && (
              <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 20 }}>
                <div style={{
                  padding: 16, borderRadius: "var(--r)",
                  background: "var(--surface2)", border: "1px solid var(--border)",
                  textAlign: "center",
                }}>
                  <div style={{
                    width: 160, height: 160, margin: "0 auto 10px",
                    borderRadius: 12,
                    background: "linear-gradient(135deg, rgba(139,92,246,0.25), rgba(109,40,217,0.1))",
                    border: "1px solid rgba(139,92,246,0.3)",
                    display: "grid", placeItems: "center", color: "var(--text3)", fontWeight: 700,
                  }}>
                    QR
                  </div>
                  <p style={{ fontSize: 12, color: "var(--text3)" }}>Escaneie o QR Code no app do seu banco</p>
                </div>
                <div style={{
                  padding: "10px 12px",
                  background: "var(--bg)",
                  border: "1px dashed var(--border2)",
                  borderRadius: "var(--r)",
                  fontFamily: "monospace",
                  fontSize: 11,
                  wordBreak: "break-all",
                  color: "var(--text2)",
                }}>
                  {pixCodeRef.current}
                </div>
                <button className="btn btn-ghost" onClick={async () => {
                  try { await navigator.clipboard?.writeText(pixCodeRef.current); } catch { /* ignore */ }
                }}>
                  Copiar código PIX
                </button>
              </div>
            )}

            {method === "boleto" && (
              <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 20 }}>
                <div style={{
                  padding: 16, borderRadius: "var(--r)",
                  background: "var(--surface2)", border: "1px solid var(--border)",
                }}>
                  <p style={{ fontSize: 12, color: "var(--text3)", marginBottom: 6 }}>Linha digitável</p>
                  <p style={{ fontFamily: "monospace", fontSize: 12, color: "var(--text)" }}>{boletoRef.current.code}</p>
                  <p style={{ fontSize: 12, color: "var(--text3)", marginTop: 10 }}>Vencimento: {boletoRef.current.dueDate}</p>
                </div>
                <button className="btn btn-ghost" onClick={async () => {
                  try { await navigator.clipboard?.writeText(boletoRef.current.code); } catch { /* ignore */ }
                }}>
                  Copiar linha digitável
                </button>
              </div>
            )}
            <div style={{ padding: "10px 14px", background: "rgba(34,197,94,0.08)", border: "1px solid rgba(34,197,94,0.2)", borderRadius: "var(--r)", marginBottom: 16, display: "flex", gap: 8, fontSize: 12, color: "var(--green)" }}>
              <Icon name="lock" size={14} /> Pagamento 100% seguro e criptografado
            </div>
            {error && (
              <div style={{ padding: "10px 14px", background: "rgba(255,71,87,0.1)", border: "1px solid rgba(255,71,87,0.2)", borderRadius: "var(--r)", marginBottom: 16, fontSize: 12, color: "var(--red)" }}>
                {error}
              </div>
            )}
            <button className="btn btn-accent" style={{ width: "100%" }} onClick={handlePay} disabled={loading}>
              {loading ? (
                <div style={{ width: 18, height: 18, border: "2px solid rgba(0,0,0,0.3)", borderTopColor: "#000", borderRadius: "50%", animation: "spin 0.7s linear infinite" }} />
              ) : (
                method === "card"
                  ? <><Icon name="check" size={16} /> Confirmar Assinatura — R$ {creator.monthlyPrice.toFixed(2)}/mês</>
                  : method === "pix"
                    ? <><Icon name="check" size={16} /> Confirmar pagamento via PIX</>
                    : <><Icon name="check" size={16} /> Gerar boleto e concluir</>
              )}
            </button>
          </>
        )}

        {step === 3 && (
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <div style={{
              width: 80, height: 80, borderRadius: "50%",
              background: "rgba(34,197,94,0.12)", border: "2px solid var(--green)",
              display: "flex", alignItems: "center", justifyContent: "center",
              margin: "0 auto 20px", animation: "popIn 0.3s ease",
            }}>
              <Icon name="check" size={36} />
            </div>
            <h2 className="syne" style={{ fontSize: 22, fontWeight: 700, color: "var(--green)", marginBottom: 8 }}>
              Assinatura ativada!
            </h2>
            <p style={{ color: "var(--text2)" }}>
              Você agora tem acesso a todo conteúdo exclusivo de {creator.name}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
const AuthScreen = ({ onLogin, onToast, onGuest }) => {
  const [mode, setMode] = useState("login");
  const [role, setRole] = useState("user");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const googleEnabled = Boolean(GOOGLE_CLIENT_ID);
  const googleWrapRef = useRef(null);
  const [googleButtonWidth, setGoogleButtonWidth] = useState(
    typeof window !== "undefined" ? String(Math.min(340, Math.max(200, window.innerWidth - 84))) : "300"
  );
  useEffect(() => {
    const updateWidth = () => {
      if (googleWrapRef.current) {
        setGoogleButtonWidth(String(Math.floor(googleWrapRef.current.offsetWidth)));
      }
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const handleSubmit = async () => {
    if (!form.email || !form.password) {
      setError("Preencha todos os campos");
      return;
    }

    setError("");
    setLoading(true);
    try {
      if (mode === "signup") {
        await api.register({
          email: form.email,
          password: form.password,
          role,
        });
      }

      const tokens = await api.login(form.email, form.password);
      await onLogin(tokens);
      onToast?.({
        type: "success",
        title: mode === "signup" ? "Conta criada" : "Bem-vindo!",
        message: mode === "signup" ? "Conta criada e login realizado com sucesso." : "Login realizado com sucesso.",
      });
    } catch (e) {
      const raw = String(e.message || "Falha ao autenticar");
      const friendly = raw.includes("Email already")
        ? "Este e-mail já está cadastrado."
        : raw.includes("credenciais") || raw.includes("Invalid credentials")
          ? "E-mail ou senha inválidos."
          : raw.includes("token inválido")
            ? "Sessão expirada. Faça login novamente."
            : "Não foi possível autenticar. Tente novamente.";
      setError(friendly);
      onToast?.({ type: "error", title: "Falha no login", message: friendly });
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async (credentialResponse) => {
    const idToken = credentialResponse?.credential;
    if (!idToken) {
      const message = "Não foi possível autenticar com Google.";
      setError(message);
      onToast?.({ type: "error", title: "Falha no login", message });
      return;
    }

    setError("");
    setLoading(true);
    try {
      const tokens = mode === "signup"
        ? await api.registerViaGoogle(idToken, role)
        : await api.loginViaGoogle(idToken);
      await onLogin(tokens);
      onToast?.({
        type: "success",
        title: mode === "signup" ? "Conta criada" : "Bem-vindo!",
        message: mode === "signup"
          ? "Cadastro com Google realizado com sucesso."
          : "Login com Google realizado com sucesso.",
      });
    } catch (e) {
      const raw = String(e.message || "Falha ao autenticar com Google.");
      const message = raw.includes("não existe") || raw.includes("not found") || raw.includes("not registered")
        ? "Conta não encontrada. Crie sua conta para continuar."
        : raw.includes("already") || raw.includes("já está") || raw.includes("already registered")
          ? "Este e-mail já possui conta. Use Entrar para continuar."
          : "Falha ao autenticar com Google. Tente novamente.";
      setError(message);
      onToast?.({ type: "error", title: "Falha no login", message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell" style={{
      minHeight: "100vh", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      background: "var(--bg)",
      position: "relative", overflow: "hidden",
    }}>
      <div style={{
        position: "absolute", width: 700, height: 700, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(139,92,246,0.12) 0%, transparent 70%)",
        top: -250, right: -150, pointerEvents: "none",
      }} />
      <div style={{
        position: "absolute", width: 500, height: 500, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(109,40,217,0.1) 0%, transparent 70%)",
        bottom: -150, left: -150, pointerEvents: "none",
      }} />

      <div className="auth-inner" style={{ width: "100%", maxWidth: 500, padding: "0 clamp(4px, 5vw, 24px)", position: "relative" }}>
        <div className="auth-logo-wrap" style={{
          display: "flex", flexDirection: "column", alignItems: "center",
          marginBottom: 36, width: "100%",
        }}>
          <div style={{
            width: "100%", display: "flex", justifyContent: "center",
            marginBottom: 10,
            filter: "drop-shadow(0 4px 24px rgba(139,92,246,0.35))",
          }}>
            <LogoSvg
              color="var(--text)"
              width={340}
              height={120}
              style={{ width: "100%", maxWidth: "min(340px, 88vw)", height: "auto" }}
            />
          </div>
          <p style={{ color: "var(--text3)", fontSize: 13, textAlign: "center" }}>
            Plataforma de criadores de conteúdo</p>
        </div>

        <div className="card auth-card" style={{ padding: 32 }}>
          <div style={{ display: "flex", background: "var(--bg)", borderRadius: "var(--r)", padding: 4, marginBottom: 24 }}>
            {[["login", "Entrar"], ["signup", "Criar conta"]].map(([m, l]) => (
              <button key={m} onClick={() => setMode(m)}
                style={{
                  flex: 1, padding: "8px", borderRadius: 8, fontSize: 14, fontWeight: 500,
                  background: mode === m ? "var(--surface2)" : "transparent",
                  color: mode === m ? "var(--text)" : "var(--text3)",
                  transition: "all 0.2s",
                }}>{l}</button>
            ))}
          </div>

          {mode === "signup" && (
            <>
              <div>
                <label style={{ fontSize: 12, color: "var(--text3)", marginBottom: 6, display: "block" }}>Tipo de conta</label>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 16 }}>
                  {[["user", "Cliente", "user"], ["creator", "Criador", "crown"]].map(([r, l, ic]) => (
                    <button key={r} onClick={() => setRole(r)}
                      style={{
                        padding: "12px", borderRadius: "var(--r)",
                        border: `2px solid ${role === r ? "var(--accent)" : "var(--border)"}`,
                        background: role === r ? "var(--accent-dim)" : "var(--bg)",
                        color: role === r ? "var(--accent)" : "var(--text2)",
                        transition: "all 0.2s", display: "flex", flexDirection: "column",
                        alignItems: "center", gap: 6, fontSize: 13, fontWeight: 500,
                      }}>
                      <Icon name={ic} size={20} />
                      {l}
                    </button>
                  ))}
                </div>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 12, color: "var(--text3)", marginBottom: 6, display: "block" }}>Nome completo</label>
                <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Seu nome" />
              </div>
            </>
          )}

          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, color: "var(--text3)", marginBottom: 6, display: "block" }}>Email</label>
            <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="seu@email.com" />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontSize: 12, color: "var(--text3)", marginBottom: 6, display: "block" }}>Senha</label>
            <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="••••••••"
              onKeyDown={e => e.key === "Enter" && handleSubmit()} />
          </div>

          {error && (
            <div style={{ padding: "10px 14px", background: "rgba(255,71,87,0.1)", border: "1px solid rgba(255,71,87,0.2)", borderRadius: "var(--r)", marginBottom: 16, fontSize: 13, color: "var(--red)" }}>
              {error}
            </div>
          )}

          <button className="btn btn-accent" style={{ width: "100%", justifyContent: "center", padding: "12px" }} onClick={handleSubmit} disabled={loading}>
            {loading ? (
              <div style={{ width: 18, height: 18, border: "2px solid rgba(0,0,0,0.3)", borderTopColor: "#000", borderRadius: "50%", animation: "spin 0.7s linear infinite" }} />
            ) : (
              mode === "login" ? "Entrar" : "Criar conta"
            )}
          </button>

          <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "14px 0" }}>
            <div style={{ flex: 1, height: 1, background: "var(--border)" }} />
            <span style={{ fontSize: 12, color: "var(--text3)" }}>ou</span>
            <div style={{ flex: 1, height: 1, background: "var(--border)" }} />
          </div>

          <div style={{ display: "flex", justifyContent: "center", marginBottom: 8 }}>
            {googleEnabled ? (
              <div ref={googleWrapRef} style={{ width: "100%", opacity: loading ? 0.65 : 1, pointerEvents: loading ? "none" : "auto" }}>
                <GoogleLogin
                  onSuccess={handleGoogleLogin}
                  onError={() => {
                    const message = "Não foi possível autenticar com Google.";
                    setError(message);
                    onToast?.({ type: "error", title: "Falha no login", message });
                  }}
                  theme={"outline"}
                  text={mode === "signup" ? "signup_with" : "continue_with"}
                  shape={"pill"}
                  width={googleButtonWidth}
                />
              </div>
            ) : (
              <button
                type="button"
                disabled
                style={{
                  width: "100%",
                  maxWidth: 360,
                  height: 40,
                  borderRadius: 999,
                  border: "1px solid var(--border)",
                  background: "var(--bg)",
                  color: "var(--text3)",
                  fontSize: 13,
                }}
                title="Configure REACT_APP_GOOGLE_CLIENT_ID para habilitar o login com Google"
              >
                Google indisponível neste ambiente
              </button>
            )}
          </div>

          {onGuest && (
            <button
              onClick={onGuest}
              style={{
                width: "100%", marginTop: 14, background: "none",
                color: "var(--text3)", fontSize: 13, padding: "8px",
                borderRadius: "var(--r)", display: "flex", alignItems: "center",
                justifyContent: "center", gap: 6, border: "none",
                transition: "color 0.2s",
              }}
              onMouseEnter={e => e.currentTarget.style.color = "var(--text2)"}
              onMouseLeave={e => e.currentTarget.style.color = "var(--text3)"}
            >
              <Icon name="explore" size={14} /> Explorar sem fazer login
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const PromoPostCard = ({ post }) => {
  const [liked, setLiked] = useState(post.liked);
  const [likes, setLikes] = useState(post.likes);

  const handleLike = () => {
    setLiked(l => !l);
    setLikes(n => liked ? n - 1 : n + 1);
  };

  return (
    <div className="card fade-in" style={{
      marginBottom: 20, overflow: "hidden", padding: 0,
      border: "1px solid rgba(139,92,246,0.35)",
      background: "linear-gradient(135deg, var(--surface) 0%, rgba(139,92,246,0.04) 100%)",
    }}>
      {/* Header */}
      <div style={{ padding: "14px 20px 10px", display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{
          width: 40, height: 40, borderRadius: "50%", flexShrink: 0,
          background: "linear-gradient(135deg,#7c3aed,#4c1d95)",
          display: "flex", alignItems: "center", justifyContent: "center",
          color: "#fff", fontWeight: 800, fontSize: 13, letterSpacing: "0.04em",
          boxShadow: "0 0 16px rgba(139,92,246,0.4)",
        }}>AF</div>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ fontWeight: 700, fontSize: 14 }}>AngelFans</span>
            <div style={{ width: 16, height: 16, borderRadius: "50%", background: "linear-gradient(135deg,#8b5cf6,#6d28d9)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Icon name="check" size={10} />
            </div>
            <span className="tag tag-accent" style={{ fontSize: 10, padding: "1px 7px" }}>Oficial</span>
          </div>
          <span style={{ fontSize: 12, color: "var(--text3)" }}>
            {new Date(post.createdAt).toLocaleDateString("pt-BR", { day: "numeric", month: "short" })}
          </span>
        </div>
        <span className="tag" style={{ background: "rgba(139,92,246,0.1)", color: "var(--accent)", border: "1px solid rgba(139,92,246,0.25)", fontSize: 10 }}>
          📣 Novidade
        </span>
      </div>

      {/* Image */}
      {post.imageUrl && (
        <div style={{ width: "100%", maxHeight: 320, overflow: "hidden" }}>
          <img src={post.imageUrl} alt="promo" style={{ width: "100%", objectFit: "cover", display: "block" }} />
        </div>
      )}

      {/* Content */}
      <div style={{ padding: "14px 20px" }}>
        <p style={{ fontSize: 14, lineHeight: 1.7, color: "var(--text)" }}>{post.content}</p>
      </div>

      {/* Actions */}
      <div style={{ padding: "0 20px 14px", display: "flex", alignItems: "center", gap: 16, borderTop: "1px solid var(--border)", paddingTop: 10 }}>
        <button onClick={handleLike} style={{
          display: "flex", alignItems: "center", gap: 6,
          background: "none", color: liked ? "var(--red)" : "var(--text3)",
          fontSize: 13, transition: "color 0.2s",
        }}>
          <svg width={16} height={16} viewBox="0 0 24 24" fill={liked ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
          </svg>
          {likes.toLocaleString("pt-BR")}
        </button>
        <span style={{ fontSize: 13, color: "var(--text3)" }}>
          <Icon name="share" size={14} /> Compartilhar
        </span>
      </div>
    </div>
  );
};

const FeedPage = ({ setPage }) => {
  const { currentUser, creators, subscriptions } = useApp();
  const [payModal, setPayModal] = useState(null);
  const { subscribe } = useApp();

  const subscribedCreators = creators.filter(c => subscriptions.includes(c.id));
  const userPosts = subscribedCreators.flatMap(c =>
    c.posts.map(p => ({ ...p, creator: c }))
  ).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  // Monta feed intercalando posts dos criadores com promos da AngelFans
  const promoPosts = [...ANGELFANS_OFFICIAL.posts].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  const mergedFeed = [];
  const promoInterval = 3; // insere 1 promo a cada N posts de criadores
  let promoIdx = 0;
  userPosts.forEach((post, i) => {
    mergedFeed.push({ ...post, _isPromo: false });
    if ((i + 1) % promoInterval === 0 && promoIdx < promoPosts.length) {
      mergedFeed.push({ ...promoPosts[promoIdx], _isPromo: true });
      promoIdx++;
    }
  });
  // Adiciona promos restantes no topo se feed de criadores for vazio ou curto
  const remainingPromos = promoPosts.slice(promoIdx);

  return (
    <div className="fade-in">
      <div style={{ marginBottom: 28 }}>
        <h1 className="syne" style={{ fontSize: 28, fontWeight: 800 }}>
          Olá, {currentUser.name.split(" ")[0]} 👋</h1>
        <p style={{ color: "var(--text2)", marginTop: 4 }}>
          {subscriptions.length > 0 ? `Você assina ${subscriptions.length} criador(es)` : "Explore e assine criadores para ver o feed"}
        </p>
      </div>

      {/* Stories — sempre mostra AngelFans + criadores assinados */}
      <div style={{ display: "flex", gap: 12, overflowX: "auto", paddingBottom: 12, marginBottom: 24 }}>
        {/* Story AngelFans Oficial */}
        <div style={{ textAlign: "center", flexShrink: 0 }}>
          <div style={{
            width: 56, height: 56, borderRadius: "50%",
            padding: 3, background: "linear-gradient(135deg, #7c3aed, #4c1d95)",
            marginBottom: 6,
            boxShadow: "0 0 12px rgba(139,92,246,0.5)",
          }}>
            <div style={{
              width: 50, height: 50, borderRadius: "50%",
              background: "linear-gradient(135deg,#8b5cf6,#4c1d95)",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: "#fff", fontWeight: 800, fontSize: 12,
            }}>AF</div>
          </div>
          <p style={{ fontSize: 11, color: "var(--accent)", maxWidth: 60, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontWeight: 600 }}>
            Oficial
          </p>
        </div>
        {subscribedCreators.map(c => (
          <div key={c.id} style={{ textAlign: "center", flexShrink: 0 }}>
            <div style={{
              width: 56, height: 56, borderRadius: "50%",
              padding: 3, background: "linear-gradient(135deg, #8b5cf6, #4c1d95)",
              marginBottom: 6,
            }}>
              <Avatar letter={c.avatarLetter} src={c.avatar} alt={c.name} size={50} />
            </div>
            <p style={{ fontSize: 11, color: "var(--text2)", maxWidth: 60, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {c.name.split(" ")[0]}
            </p>
          </div>
        ))}
      </div>

      {/* Feed: promos iniciais + posts misturados */}
      {userPosts.length === 0 ? (
        <>
          {/* Mostra todas as promos quando feed de criadores está vazio */}
          {promoPosts.map(post => <PromoPostCard key={post.id} post={post} />)}
          <div style={{ textAlign: "center", padding: "32px 20px" }}>
            <h3 className="syne" style={{ fontSize: 20, fontWeight: 700, marginBottom: 10 }}>Assine criadores para mais conteúdo</h3>
            <p style={{ color: "var(--text2)", marginBottom: 24, fontSize: 14 }}>Descubra criadores incríveis e acesse conteúdo exclusivo</p>
            <button className="btn btn-accent" style={{ padding: "12px 28px", fontSize: 15 }} onClick={() => setPage("explore")}>
              <Icon name="explore" size={18} /> Explorar Criadores
            </button>
          </div>
        </>
      ) : (
        <>
          {/* Promo pinada no topo */}
          {promoPosts[0] && <PromoPostCard key={promoPosts[0].id} post={promoPosts[0]} />}

          {/* Feed misturado */}
          {mergedFeed.map(post =>
            post._isPromo
              ? <PromoPostCard key={post.id} post={post} />
              : <PostCard key={post.id} post={post} creator={post.creator} isSubscribed={true} />
          )}

          {/* Promos restantes ao final */}
          {remainingPromos.slice(1).map(post => <PromoPostCard key={post.id} post={post} />)}
        </>
      )}

      {payModal && (
        <PaymentModal creator={payModal} onClose={() => setPayModal(null)} onSuccess={() => subscribe(payModal.id)} />
      )}
    </div>
  );
};

const PublicCreatorPage = ({ creator, isSubscribed, onBack, onSubscribe, canSubscribe = true, showPosts = true }) => {
  const [payModal, setPayModal] = useState(null);

  if (!creator) {
    return (
      <div className="card" style={{ textAlign: "center", padding: "36px 24px" }}>
        <h2 className="syne" style={{ fontSize: 22, fontWeight: 800, marginBottom: 10 }}>Criador não encontrado</h2>
        <p style={{ color: "var(--text2)", marginBottom: 16 }}>Esse perfil não existe ou não está disponível.</p>
        {onBack && (
          <button className="btn btn-ghost" onClick={onBack}>Voltar</button>
        )}
      </div>
    );
  }

  return (
    <div className="fade-in">
      {onBack && (
        <button className="btn btn-ghost" style={{ marginBottom: 24 }} onClick={onBack}>
          ← Voltar
        </button>
      )}

      <div className="explore-view-hero" style={{ borderRadius: "var(--r2)", overflow: "hidden", marginBottom: -40, height: 200, background: creator.cover }} />

      <div className="explore-view-body" style={{ padding: "0 24px", marginBottom: 24 }}>
        <div className="explore-view-top" style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: 16 }}>
          <div style={{
            border: "4px solid var(--bg)", borderRadius: "50%", marginTop: -40,
            width: 88, height: 88, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden",
          }}>
            <Avatar letter={creator.avatarLetter} src={creator.avatar} alt={creator.name} size={80} />
          </div>
          {canSubscribe && (
            <button
              className={`btn ${isSubscribed ? "btn-ghost" : "btn-accent"}`}
              onClick={() => (isSubscribed ? null : setPayModal(creator))}
            >
              {isSubscribed
                ? <><Icon name="check" size={14} /> Assinando</>
                : <><Icon name="crown" size={14} /> Assinar R${creator.monthlyPrice.toFixed(2)}/mês</>}
            </button>
          )}
        </div>

        <div className="explore-view-name-row" style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
          <h1 className="syne" style={{ fontSize: 24, fontWeight: 800 }}>{creator.name}</h1>
          {creator.verified && (
            <div style={{ width: 20, height: 20, borderRadius: "50%", background: "linear-gradient(135deg,#8b5cf6,#6d28d9)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Icon name="check" size={12} />
            </div>
          )}
        </div>
        <p style={{ color: "var(--text3)", fontSize: 14, marginBottom: 12 }}>@{creator.username}</p>
        <p style={{ color: "var(--text2)", lineHeight: 1.6, marginBottom: 16 }}>{creator.bio}</p>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 20 }}>
          {creator.tags.map((t) => <span key={t} className="tag tag-purple">{t}</span>)}
        </div>

        <div className="card explore-view-stats" style={{ display: "flex", gap: 32, background: "var(--bg2)" }}>
          {[
            ["Assinantes", creator.subscribers.toLocaleString("pt-BR"), "users"],
            ["Posts", creator.postsCount, "grid"],
            ["Mensal", `R$${creator.monthlyPrice.toFixed(2)}`, "dollar"],
          ].map(([l, v, ic]) => (
            <div key={l} style={{ flex: 1, textAlign: "center" }}>
              <Icon name={ic} size={18} style={{ color: "var(--accent)", marginBottom: 6 }} />
              <p className="syne" style={{ fontSize: 20, fontWeight: 800 }}>{v}</p>
              <p style={{ fontSize: 12, color: "var(--text3)" }}>{l}</p>
            </div>
          ))}
        </div>
      </div>

      <div style={{ padding: "0 0" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 16 }}>
          <div>
            <h2 className="syne" style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>Posts do Criador</h2>
            <p style={{ color: "var(--text3)", fontSize: 13 }}>Conteúdo do perfil exibido acima de Explorar</p>
          </div>
          {!isSubscribed && (
            <span className="tag tag-accent"><Icon name="lock" size={10} /> Posts exclusivos pedem assinatura</span>
          )}
        </div>
        {!showPosts && (
          <div className="card" style={{ marginBottom: 16, color: "var(--text2)", textAlign: "center" }}>
            Entre na plataforma para visualizar o feed deste criador.
          </div>
        )}
        {showPosts && creator.posts.map((post) => (
          <PostCard key={post.id} post={post} creator={creator} isSubscribed={isSubscribed} />
        ))}
        {showPosts && creator.posts.length === 0 && (
          <div className="card" style={{ color: "var(--text2)", textAlign: "center" }}>
            Este criador ainda não publicou conteúdos.
          </div>
        )}
      </div>

      {payModal && (
        <PaymentModal creator={payModal} onClose={() => setPayModal(null)} onSuccess={() => onSubscribe(payModal.id)} />
      )}
    </div>
  );
};

const ExplorePage = () => {
  const { creators, subscriptions, subscribe, openCreatorPage } = useApp();
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("Todos");
  const [payModal, setPayModal] = useState(null);

  const categories = ["Todos", "Arte Digital", "Tecnologia", "Fitness", "Música"];

  const filtered = creators.filter(c => {
    const matchSearch = c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.category.toLowerCase().includes(search.toLowerCase()) ||
      c.tags.some(t => t.toLowerCase().includes(search.toLowerCase()));
    const matchCat = filter === "Todos" || c.category === filter;
    return matchSearch && matchCat;
  });

  return (
    <div className="fade-in">
      <div style={{ marginBottom: 28 }}>
        <h1 className="syne" style={{ fontSize: 28, fontWeight: 800 }}>Explorar</h1>
        <p style={{ color: "var(--text2)", marginTop: 4 }}>Descubra criadores incríveis</p>
      </div>

      {/* Search */}
      <div style={{ position: "relative", marginBottom: 20 }}>
        <Icon name="explore" size={16} style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "var(--text3)" }} />
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Buscar criadores, categorias..."
          style={{ paddingLeft: 40 }} />
      </div>

      {/* Category filters */}
      <div style={{ display: "flex", gap: 8, overflowX: "auto", paddingBottom: 8, marginBottom: 24 }}>
        {categories.map(cat => (
          <button key={cat} onClick={() => setFilter(cat)}
            className={`btn ${filter === cat ? "btn-accent" : "btn-ghost"}`}
            style={{ flexShrink: 0, padding: "7px 16px", fontSize: 13 }}>
            {cat}
          </button>
        ))}
      </div>

      {/* Trending */}
      {filter === "Todos" && !search && (
        <div style={{ marginBottom: 28 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
            <Icon name="trending" size={18} />
            <h2 className="syne" style={{ fontSize: 16, fontWeight: 700 }}>Em alta</h2>
          </div>
          <div style={{ display: "flex", gap: 12, overflowX: "auto", paddingBottom: 8 }}>
            {creators.slice(0, 3).map(c => (
              <div key={c.id} onClick={() => openCreatorPage(c)}
                style={{
                  flexShrink: 0, width: 200, background: c.cover, borderRadius: "var(--r2)",
                  padding: "20px", cursor: "pointer", position: "relative", overflow: "hidden",
                  minHeight: 120,
                }}>
                <div style={{ position: "absolute", inset: 0, background: "var(--soft-scrim)", borderRadius: "var(--r2)" }} />
                <div style={{ position: "relative" }}>
                  <Avatar letter={c.avatarLetter} src={c.avatar} alt={c.name} size={40} />
                  <p className="syne" style={{ fontSize: 14, fontWeight: 700, marginTop: 8 }}>{c.name}</p>
                  <p style={{ fontSize: 11, color: "var(--text2)" }}>{c.subscribers.toLocaleString()} assinantes</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 20 }}>
        {filtered.map(c => (
          <CreatorCard key={c.id} creator={c}
            isSubscribed={subscriptions.includes(c.id)}
            onView={openCreatorPage}
            onSubscribe={() => setPayModal(c)}
          />
        ))}
        {filtered.length === 0 && (
          <div style={{ gridColumn: "1/-1", textAlign: "center", padding: 48, color: "var(--text3)" }}>
            Nenhum criador encontrado
          </div>
        )}
      </div>

      {payModal && (
        <PaymentModal creator={payModal} onClose={() => setPayModal(null)}
          onSuccess={() => subscribe(payModal.id)} />
      )}
    </div>
  );
};

const DashboardPage = () => {
  const [newPost, setNewPost] = useState({ title: "", content: "", type: "text", exclusive: true });
  const [showPostForm, setShowPostForm] = useState(false);
  const stats = {
    revenue: 2847 * 19.90,
    subscribers: 2847,
    posts: 142,
    growth: 12.4,
    views: 48920,
    engagement: 8.7,
  };

  const months = ["Ago", "Set", "Out", "Nov", "Dez", "Jan"];
  const revData = [41200, 43800, 47300, 51900, 52400, 56853];
  const maxRev = Math.max(...revData);

  return (
    <div className="fade-in">
      <div className="dashboard-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 28 }}>
        <div>
          <h1 className="syne" style={{ fontSize: 28, fontWeight: 800 }}>Dashboard</h1>
          <p style={{ color: "var(--text2)", marginTop: 4 }}>Gerencie seu canal e conteúdo</p>
        </div>
        <button className="btn btn-accent" onClick={() => setShowPostForm(!showPostForm)}>
          <Icon name="plus" size={16} /> Novo Post
        </button>
      </div>

      {/* New Post Form */}
      {showPostForm && (
        <div className="card fade-in" style={{ marginBottom: 24 }}>
          <h3 className="syne" style={{ fontSize: 16, fontWeight: 700, marginBottom: 16 }}>Criar Novo Post</h3>
          <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
            {[["text", "Texto", "comment"], ["image", "Imagem", "image"], ["video", "Vídeo", "video"]].map(([t, l, ic]) => (
              <button key={t} onClick={() => setNewPost({ ...newPost, type: t })}
                className={`btn ${newPost.type === t ? "btn-accent" : "btn-ghost"}`}
                style={{ flex: 1, justifyContent: "center", fontSize: 13 }}>
                <Icon name={ic} size={14} /> {l}
              </button>
            ))}
          </div>
          <textarea value={newPost.content} onChange={e => setNewPost({ ...newPost, content: e.target.value })}
            placeholder="Escreva seu post aqui..." rows={4} style={{ marginBottom: 14, resize: "vertical" }} />
          {(newPost.type === "image" || newPost.type === "video") && (
            <div style={{
              border: "2px dashed var(--border)", borderRadius: "var(--r)",
              padding: 32, textAlign: "center", cursor: "pointer", marginBottom: 14,
              color: "var(--text3)",
            }}>
              <Icon name="upload" size={28} />
              <p style={{ marginTop: 8, fontSize: 14 }}>Clique para fazer upload de {newPost.type === "image" ? "imagem" : "vídeo"}</p>
              <p style={{ fontSize: 12, marginTop: 4 }}>PNG, JPG, GIF até 10MB</p>
            </div>
          )}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
              <div onClick={() => setNewPost({ ...newPost, exclusive: !newPost.exclusive })}
                style={{
                  width: 40, height: 22, borderRadius: 11,
                  background: newPost.exclusive ? "var(--accent)" : "var(--surface2)",
                  position: "relative", transition: "background 0.2s",
                }}>
                <div style={{
                  position: "absolute", top: 3, left: newPost.exclusive ? "calc(100% - 19px)" : 3,
                  width: 16, height: 16, borderRadius: "50%",
                  background: "#fff", transition: "left 0.2s",
                }} />
              </div>
              <span style={{ fontSize: 13, color: "var(--text2)" }}>
                {newPost.exclusive ? <><Icon name="lock" size={14} /> Conteúdo exclusivo para assinantes</> : "Conteúdo público"}
              </span>
            </label>
            <div style={{ display: "flex", gap: 8 }}>
              <button className="btn btn-ghost" onClick={() => setShowPostForm(false)}>Cancelar</button>
              <button className="btn btn-accent"><Icon name="arrow_right" size={14} /> Publicar</button>
            </div>
          </div>
        </div>
      )}

      {/* Stats */}
      <div className="dashboard-stats-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16, marginBottom: 24 }}>
        {[
          { label: "Receita Total", value: `R$ ${(stats.revenue / 1000).toFixed(1)}k`, icon: "dollar", change: "+12.4%", positive: true },
          { label: "Assinantes", value: stats.subscribers.toLocaleString(), icon: "users", change: "+8.2%", positive: true },
          { label: "Posts", value: stats.posts, icon: "grid", change: "+5 esse mês", positive: true },
          { label: "Visualizações", value: `${(stats.views / 1000).toFixed(1)}k`, icon: "eye", change: "+18.7%", positive: true },
          { label: "Engajamento", value: `${stats.engagement}%`, icon: "heart", change: "+1.2%", positive: true },
          { label: "Crescimento", value: `+${stats.growth}%`, icon: "trending", change: "este mês", positive: true },
        ].map(s => (
          <div key={s.label} className="card" style={{ padding: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
              <span style={{ fontSize: 12, color: "var(--text3)", fontWeight: 500 }}>{s.label}</span>
              <div style={{ width: 32, height: 32, borderRadius: 8, background: "var(--accent-dim)", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--accent)" }}>
                <Icon name={s.icon} size={16} />
              </div>
            </div>
            <p className="syne" style={{ fontSize: 24, fontWeight: 800, marginBottom: 4 }}>{s.value}</p>
            <span style={{ fontSize: 12, color: s.positive ? "var(--green)" : "var(--red)" }}>{s.change}</span>
          </div>
        ))}
      </div>

      {/* Revenue Chart */}
      <div className="card" style={{ marginBottom: 24 }}>
        <h3 className="syne" style={{ fontSize: 16, fontWeight: 700, marginBottom: 20 }}>Receita nos últimos 6 meses</h3>
        <div className="dashboard-chart-bars" style={{ display: "flex", alignItems: "flex-end", gap: 12, height: 120 }}>
          {revData.map((v, i) => (
            <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
              <span style={{ fontSize: 10, color: "var(--text3)" }}>R${(v / 1000).toFixed(0)}k</span>
              <div style={{
                width: "100%", borderRadius: "4px 4px 0 0",
                height: `${(v / maxRev) * 80}px`,
                background: i === revData.length - 1
                  ? "linear-gradient(to top, #8b5cf6, #a78bfa)"
                  : "var(--surface2)",
                transition: "height 0.6s ease",
              }} />
              <span style={{ fontSize: 11, color: "var(--text3)" }}>{months[i]}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Top posts */}
      <div className="card">
        <h3 className="syne" style={{ fontSize: 16, fontWeight: 700, marginBottom: 16 }}>Posts com mais engajamento</h3>
        {[
          { title: "Tutorial: Iluminação neon no Procreate", likes: 178, comments: 24, exclusive: true },
          { title: "Novo projeto: Coleção Neon Futures", likes: 234, comments: 18, exclusive: true },
          { title: "Abrindo slots de comissão exclusivas", likes: 89, comments: 7, exclusive: false },
        ].map((p, i) => (
          <div className="dashboard-top-post-row" key={i} style={{ display: "flex", alignItems: "center", gap: 14, padding: "12px 0", borderBottom: i < 2 ? "1px solid var(--border)" : "none" }}>
            <div style={{
              width: 36, height: 36, borderRadius: 8, background: "var(--accent-dim)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 14, fontWeight: 800, color: "#c4b5fd", fontFamily: "Poppins",
              flexShrink: 0,
            }}>{i + 1}</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ fontSize: 13, fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.title}</p>
              <p style={{ fontSize: 12, color: "var(--text3)", marginTop: 2 }}>
                {p.likes} curtidas • {p.comments} comentários
              </p>
            </div>
            {p.exclusive && <span className="tag tag-accent"><Icon name="lock" size={10} /> Exclusivo</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

const SubscriptionsPage = () => {
  const { creators, subscriptions, unsubscribe, openCreatorPage } = useApp();
  const subscribed = creators.filter(c => subscriptions.includes(c.id));
  const totalMonthly = subscribed.reduce((sum, c) => sum + (c.monthlyPrice || 0), 0);

  return (
    <div className="fade-in">
      {/* Header */}
      <div style={{ marginBottom: 28 }}>
        <h1 className="syne" style={{ fontSize: 28, fontWeight: 800 }}>Minhas Assinaturas</h1>
        <p style={{ color: "var(--text2)", marginTop: 4 }}>
          {subscribed.length === 0
            ? "Você ainda não assina nenhum criador"
            : `${subscribed.length} criador${subscribed.length > 1 ? "es" : ""} assinado${subscribed.length > 1 ? "s" : ""}`}
        </p>
      </div>

      {subscribed.length === 0 ? (
        <div style={{
          textAlign: "center", padding: "64px 20px",
          background: "var(--surface)", borderRadius: "var(--r2)",
          border: "1px solid var(--border)",
        }}>
          <div style={{
            width: 72, height: 72, borderRadius: "50%",
            background: "var(--accent-dim)", display: "flex",
            alignItems: "center", justifyContent: "center",
            margin: "0 auto 20px", color: "var(--accent)",
          }}>
            <Icon name="star" size={32} />
          </div>
          <h3 className="syne" style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Sem assinaturas ativas</h3>
          <p style={{ color: "var(--text2)", fontSize: 14 }}>Explore criadores e assine para ter acesso ao conteúdo exclusivo.</p>
        </div>
      ) : (
        <>
          {/* Summary card */}
          <div style={{
            display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 24,
          }}>
            {[
              { label: "Assinaturas ativas", value: subscribed.length, icon: "star", color: "var(--accent)" },
              { label: "Total mensal", value: `R$ ${totalMonthly.toFixed(2)}`, icon: "dollar", color: "var(--green)" },
              { label: "Posts disponíveis", value: subscribed.reduce((s, c) => s + (c.postsCount || 0), 0), icon: "grid", color: "var(--purple)" },
            ].map(s => (
              <div key={s.label} className="card" style={{ padding: "16px", textAlign: "center" }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 10, margin: "0 auto 10px",
                  background: "var(--accent-dim)", display: "flex", alignItems: "center",
                  justifyContent: "center", color: s.color,
                }}>
                  <Icon name={s.icon} size={18} />
                </div>
                <p className="syne" style={{ fontSize: 20, fontWeight: 800, color: s.color }}>{s.value}</p>
                <p style={{ fontSize: 11, color: "var(--text3)", marginTop: 2 }}>{s.label}</p>
              </div>
            ))}
          </div>

          {/* Creator cards */}
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {subscribed.map(c => (
              <div key={c.id} className="card" style={{ padding: 0, overflow: "hidden" }}>
                {/* Cover banner */}
                <div style={{
                  height: 72, background: c.cover || "linear-gradient(135deg,#1a0a2e,#3b1f6e,#7c3aed)",
                  position: "relative",
                }}>
                  <div style={{
                    position: "absolute", inset: 0,
                    background: "linear-gradient(to bottom, transparent 30%, rgba(0,0,0,0.6))",
                  }} />
                  {c.verified && (
                    <div style={{
                      position: "absolute", top: 10, right: 12,
                      background: "rgba(139,92,246,0.85)", backdropFilter: "blur(6px)",
                      borderRadius: 99, padding: "3px 10px",
                      fontSize: 11, fontWeight: 600, color: "#fff",
                      display: "flex", alignItems: "center", gap: 4,
                    }}>
                      <Icon name="check" size={10} /> Verificado
                    </div>
                  )}
                </div>

                <div style={{ padding: "0 16px 16px", marginTop: -24 }}>
                  <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: 12 }}>
                    <div style={{
                      width: 52, height: 52, borderRadius: "50%",
                      border: "3px solid var(--bg)", overflow: "hidden", flexShrink: 0,
                    }}>
                      <Avatar letter={c.avatarLetter} src={c.avatar} alt={c.name} size={52} />
                    </div>
                    <div style={{ display: "flex", gap: 8, paddingBottom: 4 }}>
                      <button
                        className="btn btn-ghost"
                        style={{ fontSize: 12, padding: "6px 12px" }}
                        onClick={() => openCreatorPage(c)}
                      >
                        <Icon name="eye" size={13} /> Ver perfil
                      </button>
                      <button
                        className="btn btn-danger"
                        style={{ fontSize: 12, padding: "6px 12px" }}
                        onClick={() => unsubscribe(c.id)}
                      >
                        <Icon name="x" size={13} /> Cancelar
                      </button>
                    </div>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
                    <h3 style={{ fontSize: 15, fontWeight: 700 }}>{c.name}</h3>
                    {c.verified && (
                      <div style={{
                        width: 16, height: 16, borderRadius: "50%",
                        background: "linear-gradient(135deg,#8b5cf6,#6d28d9)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                      }}>
                        <Icon name="check" size={9} />
                      </div>
                    )}
                  </div>
                  <p style={{ fontSize: 12, color: "var(--text3)", marginBottom: 12 }}>@{c.username}</p>

                  {/* Stats row */}
                  <div style={{ display: "flex", gap: 20, borderTop: "1px solid var(--border)", paddingTop: 12 }}>
                    {[
                      { label: "Posts", value: c.postsCount || 0 },
                      { label: "Assinantes", value: (c.subscribers || 0).toLocaleString() },
                      { label: "Plano", value: `R$ ${(c.monthlyPrice || 0).toFixed(2)}/mês`, accent: true },
                    ].map(s => (
                      <div key={s.label}>
                        <p className="syne" style={{
                          fontSize: 15, fontWeight: 700,
                          color: s.accent ? "var(--accent)" : "var(--text)",
                        }}>{s.value}</p>
                        <p style={{ fontSize: 11, color: "var(--text3)" }}>{s.label}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

const ProfilePage = () => {
  const { currentUser, creators, updateProfile, changeRole, addToast } = useApp();
  const avatarFileInputRef = useRef(null);
  const coverFileInputRef = useRef(null);
  const myCreatorProfile = creators.find((c) => c.userId === currentUser.id || c.id === currentUser.id);
  const initialDraft = {
    displayName: currentUser.name || "",
    username: currentUser.username || "",
    bio: myCreatorProfile?.bio || "",
    avatarUrl: currentUser.avatar || "",
    coverUrl: myCreatorProfile?.cover || "",
  };
  const [activeTab, setActiveTab] = useState("public");
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState(initialDraft);
  const [postDraft, setPostDraft] = useState({
    type: "text",
    content: "",
    mediaUrl: "",
    exclusive: true,
  });
  const [posting, setPosting] = useState(false);
  const [localPosts, setLocalPosts] = useState([]);
  const [prefs, setPrefs] = useState({
    emailNotifications: true,
    pushNotifications: true,
    weeklyNewsletter: false,
    showOnlineStatus: true,
  });
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [changingPassword, setChangingPassword] = useState(false);
  const [changingRole, setChangingRole] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setDraft({
      displayName: currentUser.name || "",
      username: currentUser.username || "",
      bio: myCreatorProfile?.bio || "",
      avatarUrl: currentUser.avatar || "",
      coverUrl: myCreatorProfile?.cover || "",
    });
    setIsEditing(false);
  }, [currentUser, myCreatorProfile]);

  const onSubmit = async (event) => {
    event?.preventDefault?.();
    if (!isEditing || !hasChanges) return;
    try {
      setSaving(true);
      const payload = {
        displayName: draft.displayName.trim(),
        bio: draft.bio.trim(),
        avatarUrl: draft.avatarUrl.trim() || undefined,
        coverUrl: currentUser.role === "creator" ? (draft.coverUrl.trim() || undefined) : undefined,
        username: currentUser.role === "creator" && draft.username.trim()
          ? toUnifiedSlug(draft.username, "")
          : undefined,
      };
      await updateProfile({
        ...payload,
      });
      addToast({ type: "success", title: "Perfil atualizado", message: "Suas alterações foram salvas." });
      setIsEditing(false);
    } catch (error) {
      addToast({ type: "error", title: "Erro ao salvar", message: friendlyError(error) });
    } finally {
      setSaving(false);
    }
  };

  const editCoverInline = () => {
    if (!isEditing) return;
    coverFileInputRef.current?.click();
  };

  const editAvatarInline = () => {
    if (!isEditing) return;
    avatarFileInputRef.current?.click();
  };

  const importImageAsDataUrl = (file, field) => {
    if (!file) return;
    if (!file.type?.startsWith("image/")) {
      addToast({ type: "error", title: "Arquivo inválido", message: "Selecione uma imagem válida." });
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const value = String(reader.result || "");
      if (!value) return;
      setDraft((item) => ({ ...item, [field]: value }));
      addToast({ type: "success", title: "Imagem importada", message: field === "coverUrl" ? "Capa atualizada." : "Foto de perfil atualizada." });
      if (field === "coverUrl") {
        if (coverFileInputRef.current) coverFileInputRef.current.value = "";
      } else {
        if (avatarFileInputRef.current) avatarFileInputRef.current.value = "";
      }
    };
    reader.onerror = () => {
      addToast({ type: "error", title: "Falha no import", message: "Não foi possível ler essa imagem." });
    };
    reader.readAsDataURL(file);
  };

  const editCoverByUrl = () => {
    if (!isEditing) return;
    const nextCover = window.prompt("Cole a URL da nova capa", draft.coverUrl || "");
    if (nextCover === null) return;
    setDraft((item) => ({ ...item, coverUrl: nextCover.trim() }));
  };

  const editAvatarByUrl = () => {
    if (!isEditing) return;
    const nextAvatar = window.prompt("Cole a URL da nova foto de perfil", draft.avatarUrl || "");
    if (nextAvatar === null) return;
    setDraft((item) => ({ ...item, avatarUrl: nextAvatar.trim() }));
  };

  const hasChanges =
    (draft.displayName || "").trim() !== (initialDraft.displayName || "").trim() ||
    toUnifiedSlug((draft.username || "").trim(), "") !== toUnifiedSlug((initialDraft.username || "").trim(), "") ||
    (draft.bio || "").trim() !== (initialDraft.bio || "").trim() ||
    (draft.avatarUrl || "").trim() !== (initialDraft.avatarUrl || "").trim() ||
    (draft.coverUrl || "").trim() !== (initialDraft.coverUrl || "").trim();

  const profilePreview = {
    name: draft.displayName.trim() || currentUser.name,
    username: draft.username.trim() ? toUnifiedSlug(draft.username, "") : (currentUser.username || ""),
    avatar: draft.avatarUrl.trim() || currentUser.avatar || null,
    cover: draft.coverUrl.trim() || myCreatorProfile?.cover || "linear-gradient(135deg,#1a1a2e,#16213e,#0f3460)",
    bio: draft.bio.trim() || myCreatorProfile?.bio || "Criador de conteúdo",
    subscribers: myCreatorProfile?.subscribers || 0,
    monthlyPrice: myCreatorProfile?.monthlyPrice || 19.9,
    postsCount: (myCreatorProfile?.postsCount || 0) + localPosts.length,
  };

  const publishedPosts = [...localPosts, ...(myCreatorProfile?.posts || [])].slice(0, 4);

  const submitPost = async () => {
    if (!postDraft.content.trim()) {
      addToast({ type: "error", title: "Post vazio", message: "Escreva algo antes de publicar." });
      return;
    }

    try {
      setPosting(true);
      const payload = {
        type: postDraft.type,
        content: postDraft.content.trim(),
        exclusive: postDraft.exclusive,
        mediaUrl: postDraft.mediaUrl.trim() || undefined,
      };
      const created = await api.createPost(payload);
      const normalized = toPostViewModel(created || {
        ...payload,
        id: `${Date.now()}`,
        createdAt: new Date().toISOString(),
      });
      setLocalPosts((items) => [normalized, ...items]);
      setPostDraft({ type: "text", content: "", mediaUrl: "", exclusive: true });
      addToast({ type: "success", title: "Post publicado", message: "Seu conteúdo já está no perfil." });
    } catch (error) {
      addToast({ type: "error", title: "Falha ao publicar", message: friendlyError(error, "Não foi possível publicar o post.") });
    } finally {
      setPosting(false);
    }
  };

  const togglePref = (key) => setPrefs((items) => ({ ...items, [key]: !items[key] }));

  const submitPasswordChange = async (event) => {
    event.preventDefault();
    if (!passwordForm.currentPassword || !passwordForm.newPassword || !passwordForm.confirmPassword) {
      addToast({ type: "error", title: "Campos obrigatórios", message: "Preencha todos os campos de senha." });
      return;
    }
    if (passwordForm.newPassword.length < 6) {
      addToast({ type: "error", title: "Senha fraca", message: "A nova senha deve ter pelo menos 6 caracteres." });
      return;
    }
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      addToast({ type: "error", title: "Confirmação inválida", message: "A confirmação da senha não confere." });
      return;
    }

    try {
      setChangingPassword(true);
      await api.changePassword(passwordForm.currentPassword, passwordForm.newPassword);
      setPasswordForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
      addToast({ type: "success", title: "Senha atualizada", message: "Sua senha foi alterada com sucesso." });
    } catch (error) {
      addToast({ type: "error", title: "Não foi possível alterar", message: friendlyError(error, "Verifique os dados e tente novamente.") });
    } finally {
      setChangingPassword(false);
    }
  };

  const handleChangeRole = async () => {
    const newRole = currentUser.role === "creator" ? "user" : "creator";
    try {
      setChangingRole(true);
      await changeRole(newRole);
      addToast({
        type: "success",
        title: "Tipo de conta alterado",
        message: newRole === "creator" ? "Você agora é um criador de conteúdo." : "Você agora é um assinante.",
      });
    } catch (error) {
      addToast({ type: "error", title: "Não foi possível alterar", message: friendlyError(error, "Tente novamente.") });
    } finally {
      setChangingRole(false);
    }
  };

  return (
    <div className="fade-in">
      <h1 className="syne" style={{ fontSize: 28, fontWeight: 800, marginBottom: 18 }}>Meu Perfil</h1>

      <div style={{ display: "flex", gap: 8, marginBottom: 18, flexWrap: "wrap" }}>
        <button
          className={`btn ${activeTab === "public" ? "btn-accent" : "btn-ghost"}`}
          onClick={() => setActiveTab("public")}
          style={{ padding: "8px 14px" }}
        >
          <Icon name="user" size={14} /> Perfil Público
        </button>
        <button
          className={`btn ${activeTab === "options" ? "btn-accent" : "btn-ghost"}`}
          onClick={() => setActiveTab("options")}
          style={{ padding: "8px 14px" }}
        >
          <Icon name="settings" size={14} /> Opções
        </button>
      </div>

      {activeTab === "public" ? (
        <>
          <input
            ref={coverFileInputRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={(event) => importImageAsDataUrl(event.target.files?.[0], "coverUrl")}
          />
          <input
            ref={avatarFileInputRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={(event) => importImageAsDataUrl(event.target.files?.[0], "avatarUrl")}
          />

          <div
            className="explore-view-hero"
            style={{ borderRadius: "var(--r2)", overflow: "hidden", marginBottom: -40, height: 200, background: profilePreview.cover, position: "relative", cursor: isEditing ? "pointer" : "default" }}
            onClick={isEditing ? editCoverInline : undefined}
            title={isEditing ? "Clique para editar a capa" : undefined}
          >
            {isEditing && (
              <div style={{ position: "absolute", inset: 0, background: "rgba(10,8,18,0.18)", display: "grid", placeItems: "center" }}>
                <span className="tag tag-accent"><Icon name="settings" size={10} /> Clique para trocar capa</span>
              </div>
            )}
          </div>

          <div className="explore-view-body" style={{ padding: "0 24px", marginBottom: 20 }}>
            <div className="explore-view-top" style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: 14, gap: 10, flexWrap: "wrap" }}>
              <div style={{
                border: "4px solid var(--bg)", borderRadius: "50%", marginTop: -40,
                width: 88, height: 88, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", position: "relative", cursor: isEditing ? "pointer" : "default",
              }} onClick={isEditing ? editAvatarInline : undefined} title={isEditing ? "Clique para editar a foto" : undefined}>
                <Avatar letter={profilePreview.name[0]} src={profilePreview.avatar} alt={profilePreview.name} size={80} />
                {isEditing && (
                  <div style={{
                    position: "absolute", inset: 0,
                    background: "rgba(10,8,18,0.22)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    color: "#fff", fontSize: 11, fontWeight: 700,
                  }}>
                    Editar
                  </div>
                )}
              </div>
              {currentUser.role === "creator" && !isEditing && (
                <div className="tag tag-accent" style={{ alignSelf: "center", display: "inline-flex", gap: 6 }}>
                  <Icon name="crown" size={10} /> Perfil de criador
                </div>
              )}
            </div>

            <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
              <button
                className={`btn ${isEditing ? "btn-accent" : "btn-ghost"}`}
                style={{ padding: "7px 12px" }}
                onClick={() => {
                  if (isEditing && hasChanges) {
                    setDraft(initialDraft);
                  }
                  setIsEditing((value) => !value);
                }}
              >
                <Icon name="settings" size={13} /> {isEditing ? "Sair da edição" : "Modo edição"}
              </button>
              {isEditing && (
                <>
                  <button className="btn btn-ghost" style={{ padding: "7px 12px" }} onClick={editAvatarByUrl}>URL foto</button>
                  <button className="btn btn-ghost" style={{ padding: "7px 12px" }} onClick={editCoverByUrl}>URL capa</button>
                </>
              )}
            </div>

            <div className="explore-view-name-row" style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
              {isEditing ? (
                <input
                  value={draft.displayName}
                  onChange={(event) => setDraft((item) => ({ ...item, displayName: event.target.value }))}
                  placeholder="Seu nome público"
                  maxLength={80}
                  style={{ fontSize: 24, fontWeight: 800, border: "1px solid var(--border)", background: "var(--surface)", padding: "8px 10px" }}
                />
              ) : (
                <h2 className="syne" style={{ fontSize: 24, fontWeight: 800 }}>{profilePreview.name}</h2>
              )}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
              {isEditing ? (
                <>
                  <span style={{ color: "var(--text3)", fontSize: 14 }}>@</span>
                  <input
                    value={draft.username}
                    onChange={(event) => setDraft((item) => ({ ...item, username: event.target.value }))}
                    placeholder="username"
                    maxLength={30}
                    style={{ fontSize: 14, color: "var(--text3)", border: "1px solid var(--border)", background: "var(--surface)", padding: "8px 10px" }}
                  />
                </>
              ) : (
                <p style={{ color: "var(--text3)", fontSize: 14 }}>
                  {profilePreview.username ? `@${profilePreview.username}` : "Sem username público"}
                </p>
              )}
            </div>
            {isEditing ? (
              <textarea
                value={draft.bio}
                onChange={(event) => setDraft((item) => ({ ...item, bio: event.target.value }))}
                placeholder="Escreva sua bio"
                maxLength={300}
                rows={3}
                style={{ color: "var(--text2)", lineHeight: 1.6, marginBottom: 16, resize: "vertical", background: "var(--bg2)" }}
              />
            ) : (
              <p style={{ color: "var(--text2)", lineHeight: 1.6, marginBottom: 16 }}>{profilePreview.bio}</p>
            )}

            <p style={{ fontSize: 12, color: "var(--text3)", marginBottom: 12 }}>
              URL pública: /{draft.username.trim() ? toUnifiedSlug(draft.username, "") : "seu_username"}
            </p>

            <div className="card explore-view-stats" style={{ display: "flex", gap: 32, background: "var(--bg2)" }}>
              {[
                ["Assinantes", profilePreview.subscribers.toLocaleString("pt-BR"), "users"],
                ["Posts", profilePreview.postsCount, "grid"],
                ["Mensal", `R$${profilePreview.monthlyPrice.toFixed(2)}`, "dollar"],
              ].map(([label, value, icon]) => (
                <div key={label} style={{ flex: 1, textAlign: "center" }}>
                  <Icon name={icon} size={18} style={{ color: "var(--accent)", marginBottom: 6 }} />
                  <p className="syne" style={{ fontSize: 20, fontWeight: 800 }}>{value}</p>
                  <p style={{ fontSize: 12, color: "var(--text3)" }}>{label}</p>
                </div>
              ))}
            </div>

            {isEditing && (
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
                <button className="btn btn-accent" onClick={onSubmit} disabled={!hasChanges || saving}>
                  {saving ? "Salvando..." : <><Icon name="check" size={13} /> Salvar alterações</>}
                </button>
              </div>
            )}
          </div>

          {currentUser.role === "creator" && (
            <>
              <div className="card" style={{ marginBottom: 16 }}>
                <h3 className="syne" style={{ fontSize: 17, fontWeight: 700, marginBottom: 12 }}>Criar post</h3>
                <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
                  {["text", "image", "video"].map((type) => (
                    <button
                      key={type}
                      className={`btn ${postDraft.type === type ? "btn-accent" : "btn-ghost"}`}
                      style={{ padding: "7px 12px", fontSize: 13 }}
                      onClick={() => setPostDraft((item) => ({ ...item, type }))}
                    >
                      <Icon name={type === "text" ? "comment" : type === "image" ? "image" : "play"} size={13} /> {type}
                    </button>
                  ))}
                </div>

                <textarea
                  rows={4}
                  value={postDraft.content}
                  onChange={(e) => setPostDraft((item) => ({ ...item, content: e.target.value }))}
                  placeholder="Escreva o conteúdo do post..."
                  style={{ marginBottom: 10 }}
                />

                {(postDraft.type === "image" || postDraft.type === "video") && (
                  <input
                    value={postDraft.mediaUrl}
                    onChange={(e) => setPostDraft((item) => ({ ...item, mediaUrl: e.target.value }))}
                    placeholder="URL da mídia (opcional)"
                    style={{ marginBottom: 10 }}
                  />
                )}

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                  <button
                    className="btn btn-ghost"
                    style={{ padding: "8px 12px" }}
                    onClick={() => setPostDraft((item) => ({ ...item, exclusive: !item.exclusive }))}
                  >
                    <Icon name={postDraft.exclusive ? "lock" : "eye"} size={13} /> {postDraft.exclusive ? "Exclusivo" : "Público"}
                  </button>
                  <button className="btn btn-accent" onClick={submitPost} disabled={posting}>
                    {posting ? "Publicando..." : <><Icon name="plus" size={13} /> Publicar post</>}
                  </button>
                </div>
              </div>

              <div className="card">
                <h3 className="syne" style={{ fontSize: 16, fontWeight: 700, marginBottom: 12 }}>Últimos posts</h3>
                {publishedPosts.length === 0 ? (
                  <p style={{ color: "var(--text3)", fontSize: 14 }}>Você ainda não publicou conteúdos.</p>
                ) : (
                  <div style={{ display: "grid", gap: 10 }}>
                    {publishedPosts.map((post) => (
                      <div key={post.id} style={{
                        border: "1px solid var(--border)", borderRadius: "var(--r)", padding: "12px 14px",
                        background: "var(--bg2)",
                      }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                          <span className="tag tag-blue">{post.type || "text"}</span>
                          {post.exclusive && <span className="tag tag-accent"><Icon name="lock" size={10} /> Exclusivo</span>}
                        </div>
                        <p style={{ color: "var(--text2)", fontSize: 14, lineHeight: 1.5 }}>{post.content}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}
        </>
      ) : (
        <div className="card">
          <h3 className="syne" style={{ fontSize: 18, fontWeight: 700, marginBottom: 14 }}>
            <Icon name="settings" size={16} /> Opções da conta
          </h3>

          <div style={{ marginBottom: 18 }}>
            <h4 className="syne" style={{ fontSize: 15, fontWeight: 700, marginBottom: 10 }}>Preferências</h4>
            {[
              ["emailNotifications", "Notificações por e-mail"],
              ["pushNotifications", "Notificações push"],
              ["weeklyNewsletter", "Newsletter semanal"],
              ["showOnlineStatus", "Mostrar status online"],
            ].map(([key, label]) => (
              <div key={key} className="profile-pref-row" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
                <span style={{ fontSize: 14, color: "var(--text2)" }}>{label}</span>
                <button
                  onClick={() => togglePref(key)}
                  style={{
                    width: 40, height: 22, borderRadius: 11,
                    background: prefs[key] ? "var(--accent)" : "var(--surface2)",
                    position: "relative",
                  }}
                >
                  <span style={{
                    position: "absolute", top: 3, left: prefs[key] ? "calc(100% - 19px)" : 3,
                    width: 16, height: 16, borderRadius: "50%", background: "#fff",
                  }} />
                </button>
              </div>
            ))}
          </div>

          <div className="divider" />

          <div style={{ marginBottom: 18 }}>
            <h4 className="syne" style={{ fontSize: 15, fontWeight: 700, marginBottom: 6 }}>Tipo de conta</h4>
            <p style={{ fontSize: 13, color: "var(--text3)", marginBottom: 14 }}>
              {currentUser.role === "creator"
                ? "Você é um criador de conteúdo. Pode publicar posts e receber assinantes."
                : "Você é um assinante. Pode assinar criadores e acessar conteúdos exclusivos."}
            </p>
            <button
              className="btn btn-ghost"
              onClick={handleChangeRole}
              disabled={changingRole}
              style={{ padding: "10px 18px", fontSize: 13 }}
            >
              {changingRole
                ? "Atualizando..."
                : currentUser.role === "creator"
                  ? <><Icon name="user" size={14} /> Mudar para Assinante</>
                  : <><Icon name="crown" size={14} /> Tornar-se Criador</>}
            </button>
          </div>

          <div className="divider" />

          <form onSubmit={submitPasswordChange} style={{ display: "grid", gap: 10 }}>
            <h4 className="syne" style={{ fontSize: 15, fontWeight: 700 }}>Alterar senha</h4>
            <input
              type="password"
              value={passwordForm.currentPassword}
              onChange={(e) => setPasswordForm((item) => ({ ...item, currentPassword: e.target.value }))}
              placeholder="Senha atual"
            />
            <input
              type="password"
              value={passwordForm.newPassword}
              onChange={(e) => setPasswordForm((item) => ({ ...item, newPassword: e.target.value }))}
              placeholder="Nova senha"
            />
            <input
              type="password"
              value={passwordForm.confirmPassword}
              onChange={(e) => setPasswordForm((item) => ({ ...item, confirmPassword: e.target.value }))}
              placeholder="Confirmar nova senha"
            />
            <button className="btn btn-accent" type="submit" disabled={changingPassword} style={{ justifyContent: "center", marginTop: 4 }}>
              {changingPassword ? "Atualizando..." : "Salvar nova senha"}
            </button>
          </form>
        </div>
      )}
    </div>
  );
};
const LandingPage = ({ onLogin, creators: propCreators, theme, toggleTheme }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const apiCreators = Array.isArray(propCreators) ? propCreators : [];
  // Sempre usar mocks como base; criadores reais da API sobrescrevem por username
  const apiUsernames = new Set(apiCreators.map(c => c.username));
  const fallbackCreators = MOCK_LANDING_CREATORS.filter(m => !apiUsernames.has(m.username));
  const usedCreators = [...apiCreators, ...fallbackCreators];

  // Inclui posts da AngelFans oficial + criadores
  const officialPostsAsCreatorPosts = ANGELFANS_OFFICIAL.posts.map(p => ({
    ...p,
    creator: ANGELFANS_OFFICIAL,
    score: p.likes + 10000, // sempre priorizado no topo
  }));
  const trendingPosts = [
    ...officialPostsAsCreatorPosts,
    ...usedCreators
      .flatMap(c => c.posts.map(p => ({
        ...p,
        creator: c,
        score: p.likes + 2 * (Array.isArray(p.comments) ? p.comments.length : Number(p.comments || 0)),
      })))
      .sort((a, b) => b.score - a.score || new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, 6),
  ].slice(0, 9);

  const typeIcons = { image: "image", video: "play", text: "comment" };
  const typeColors = { image: "var(--purple)", video: "var(--blue)", text: "var(--green)" };

  const totalPosts = usedCreators.reduce((s, c) => s + c.posts.length, 0);
  const totalLikes = usedCreators.flatMap(c => c.posts).reduce((s, p) => s + p.likes, 0);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(180deg, var(--bg) 0%, var(--bg2) 100%)" }}>
      {/* Top nav */}
      <header className="landing-header" style={{
        position: "sticky", top: 0, zIndex: 100,
        background: "var(--scrim)", backdropFilter: "blur(12px)",
        borderBottom: "1px solid var(--border)",
      }}>
        <div className="landing-header-inner">
          <div className="landing-brand-wrap">
            <LandingBrand />
          </div>
          <div className="landing-header-actions" style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <button
              className="btn btn-ghost"
              style={{ padding: "8px 14px", fontSize: 13 }}
              onClick={toggleTheme}
            >
              <Icon name={theme === "dark" ? "sun" : "moon"} size={15} /> {theme === "dark" ? "Claro" : "Escuro"}
            </button>
            <button className="btn btn-ghost" style={{ padding: "8px 18px", fontSize: 13 }} onClick={onLogin}>
              <Icon name="user" size={15} /> Entrar
            </button>
            <button className="btn btn-accent" style={{ padding: "8px 18px", fontSize: 13 }} onClick={onLogin}>
              <Icon name="crown" size={15} /> Criar conta
            </button>
          </div>
          <button
            className="landing-mobile-menu-button"
            onClick={() => setIsMenuOpen((open) => !open)}
            style={{
              width: 40, height: 40, borderRadius: 12,
              background: "var(--surface)", border: "1px solid var(--border)",
              color: "var(--text)", flexShrink: 0,
            }}
            aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
          >
            <Icon name={isMenuOpen ? "x" : "menu"} size={18} />
          </button>
        </div>
      </header>

      {isMenuOpen && (
        <div
          className="landing-mobile-drawer-backdrop"
          onClick={closeMenu}
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.35)", zIndex: 120 }}
        />
      )}

      <aside
        className="landing-mobile-drawer"
        style={{
          position: "fixed", top: 0, right: 0, height: "100vh", width: 280,
          background: "var(--bg2)", borderLeft: "1px solid var(--border)", zIndex: 130,
          transform: isMenuOpen ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.25s ease", flexDirection: "column",
          boxShadow: "var(--shadow2)", padding: 18,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
          <LandingBrand compact />
          <button onClick={closeMenu} style={{ width: 40, height: 40, borderRadius: 12, background: "var(--surface)", border: "1px solid var(--border)", color: "var(--text)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <Icon name="x" size={18} />
          </button>
        </div>
        <button
          className="btn btn-ghost"
          style={{ width: "100%", justifyContent: "center", marginBottom: 10, padding: "12px 14px" }}
          onClick={() => { toggleTheme(); closeMenu(); }}
        >
          <Icon name={theme === "dark" ? "sun" : "moon"} size={16} /> {theme === "dark" ? "Modo claro" : "Modo escuro"}
        </button>
        <button
          className="btn btn-ghost"
          style={{ width: "100%", justifyContent: "center", marginBottom: 10, padding: "12px 14px" }}
          onClick={() => { closeMenu(); onLogin(); }}
        >
          <Icon name="user" size={16} /> Entrar
        </button>
        <button
          className="btn btn-accent"
          style={{ width: "100%", justifyContent: "center", padding: "12px 14px" }}
          onClick={() => { closeMenu(); onLogin(); }}
        >
          <Icon name="crown" size={16} /> Criar conta
        </button>
      </aside>

      {/* Hero */}
      <div style={{
        position: "relative", overflow: "hidden",
        padding: "64px 24px 48px", textAlign: "center",
        borderBottom: "1px solid var(--border)",
      }}>
        <div style={{
          position: "absolute", width: 700, height: 700, borderRadius: "50%",
          background: "radial-gradient(circle, rgba(139,92,246,0.14) 0%, transparent 70%)",
          top: -280, left: "50%", transform: "translateX(-50%)", pointerEvents: "none",
        }} />
        <span className="tag tag-accent" style={{ marginBottom: 20, display: "inline-flex" }}>
          <Icon name="trending" size={11} /> Plataforma ativa agora
        </span>
        <h1 className="syne" style={{ fontSize: "clamp(28px, 5vw, 48px)", fontWeight: 900, lineHeight: 1.15, marginBottom: 16 }}>
          Conteúdo exclusivo dos<br />
          <span style={{ color: "var(--accent)" }}>melhores criadores</span>
        </h1>
        <p style={{ fontSize: 16, color: "var(--text2)", maxWidth: 480, margin: "0 auto 36px", lineHeight: 1.6 }}>
          Posts sendo publicados agora. Crie sua conta e assine para acessar o conteúdo completo.
        </p>

        {/* Stats */}
        <div style={{ display: "flex", justifyContent: "center", gap: "clamp(16px, 4vw, 48px)", marginBottom: 36, flexWrap: "wrap" }}>
          {[
            [usedCreators.length, "Criadores"],
            [totalPosts, "Posts publicados"],
            [totalLikes.toLocaleString("pt-BR"), "Curtidas"],
          ].map(([value, label]) => (
            <div key={label} style={{ textAlign: "center" }}>
              <p className="syne" style={{ fontSize: 28, fontWeight: 800, color: "var(--accent)" }}>{value}</p>
              <p style={{ fontSize: 13, color: "var(--text3)" }}>{label}</p>
            </div>
          ))}
        </div>

        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <button className="btn btn-accent" style={{ padding: "13px 32px", fontSize: 15 }} onClick={onLogin}>
            <Icon name="arrow_right" size={16} /> Entrar na plataforma
          </button>
          <button className="btn btn-ghost" style={{ padding: "13px 32px", fontSize: 15 }} onClick={onLogin}>
            <Icon name="user" size={16} /> Criar conta grátis
          </button>
        </div>
      </div>

      {/* Body */}
      <div style={{ maxWidth: 940, margin: "0 auto", padding: "40px 24px" }}>

        {/* Trending posts */}
        {trendingPosts.length > 0 && (
          <section style={{ marginBottom: 48 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 24 }}>
              <Icon name="trending" size={20} />
              <h2 className="syne" style={{ fontSize: 20, fontWeight: 800 }}>Posts em alta agora</h2>
              <div style={{ flex: 1, height: 1, background: "var(--border)", marginLeft: 12 }} />
              <span style={{ fontSize: 12, color: "var(--text3)", flexShrink: 0 }}>
                {trendingPosts.length} recentes
              </span>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(min(270px, 90vw), 1fr))", gap: 16 }}>
              {trendingPosts.map(post => {
                const isBlurred = post.exclusive;
                return (
                  <div key={post.id} className="card fade-in" style={{ padding: 0, overflow: "hidden", cursor: "pointer", transition: "box-shadow 0.2s, transform 0.2s" }}
                    onClick={onLogin}
                    onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 8px 32px rgba(139,92,246,0.2)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
                    onMouseLeave={e => { e.currentTarget.style.boxShadow = ""; e.currentTarget.style.transform = ""; }}>

                    {/* Header */}
                    <div style={{ padding: "14px 16px 10px", display: "flex", alignItems: "center", gap: 10 }}>
                      <Avatar letter={post.creator.avatarLetter} src={post.creator.avatar} alt={post.creator.name} size={36} />
                      <div style={{ flex: 1 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                          <span style={{ fontWeight: 600, fontSize: 13 }}>{post.creator.name}</span>
                          {post.creator.verified && (
                            <div style={{ width: 14, height: 14, borderRadius: "50%", background: "linear-gradient(135deg,#8b5cf6,#6d28d9)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                              <Icon name="check" size={9} />
                            </div>
                          )}
                        </div>
                        <span style={{ fontSize: 11, color: "var(--text3)" }}>
                          {new Date(post.createdAt).toLocaleDateString("pt-BR", { day: "numeric", month: "short" })}
                        </span>
                      </div>
                      {post.exclusive && (
                        <span className="tag tag-accent" style={{ fontSize: 10, flexShrink: 0 }}>
                          <Icon name="lock" size={9} /> Exclusivo
                        </span>
                      )}
                    </div>

                    {/* Text content */}
                    <div style={{ padding: "0 16px 12px", position: "relative" }}>
                      <p style={{
                        fontSize: 13, lineHeight: 1.55, color: "var(--text2)",
                        overflow: "hidden", display: "-webkit-box",
                        WebkitLineClamp: 2, WebkitBoxOrient: "vertical",
                        filter: isBlurred ? "blur(5px)" : "none",
                        userSelect: isBlurred ? "none" : "auto",
                      }}>{post.content}</p>
                      {isBlurred && !post.imageUrl && (
                        <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 6, background: "var(--surface)", border: "1px solid var(--border2)", padding: "5px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600, color: "var(--accent)" }}>
                            <Icon name="lock" size={12} /> Assine para ver
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Image */}
                    {post.imageUrl && (
                      <div style={{ position: "relative", overflow: "hidden", height: 180 }}>
                        <img src={post.imageUrl} alt="" style={{
                          width: "100%", height: "100%", objectFit: "cover",
                          filter: isBlurred ? "blur(18px)" : "none",
                          transform: isBlurred ? "scale(1.1)" : "none",
                          display: "block",
                        }} />
                        {isBlurred && (
                          <div style={{
                            position: "absolute", inset: 0, background: "var(--soft-scrim)",
                            display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 10,
                          }}>
                            <Icon name="lock" size={28} />
                            <span style={{ fontSize: 13, fontWeight: 600 }}>Conteúdo exclusivo</span>
                            <button className="btn btn-accent" style={{ padding: "6px 18px", fontSize: 13 }} onClick={e => { e.stopPropagation(); onLogin(); }}>
                              Entrar para ver
                            </button>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Footer stats */}
                    <div style={{ padding: "10px 16px", display: "flex", alignItems: "center", gap: 14, borderTop: "1px solid var(--border)" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 5, color: "var(--text3)", fontSize: 13 }}>
                        <Icon name="heart" size={14} /> {post.likes}
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 5, color: "var(--text3)", fontSize: 13 }}>
                        <Icon name="comment" size={14} /> {Array.isArray(post.comments) ? post.comments.length : post.comments}
                      </div>
                      <div style={{ flex: 1 }} />
                      <span className="tag" style={{ background: `${typeColors[post.type]}18`, color: typeColors[post.type], border: `1px solid ${typeColors[post.type]}30`, fontSize: 10 }}>
                        <Icon name={typeIcons[post.type]} size={9} /> {post.type}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        )}

        {trendingPosts.length === 0 && (
          <div style={{ textAlign: "center", padding: "64px 20px", marginBottom: 48 }}>
            <div style={{ width: 80, height: 80, borderRadius: "50%", background: "var(--surface)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
              <Icon name="trending" size={32} />
            </div>
            <h3 className="syne" style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Nenhum post ainda</h3>
            <p style={{ color: "var(--text2)", marginBottom: 24 }}>Seja o primeiro a publicar!</p>
            <button className="btn btn-accent" style={{ padding: "12px 28px" }} onClick={onLogin}>Criar conta</button>
          </div>
        )}

        {/* Creator highlights */}
        <section style={{ marginBottom: 48 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 24 }}>
            <Icon name="crown" size={20} />
            <h2 className="syne" style={{ fontSize: 20, fontWeight: 800 }}>Criadores em destaque</h2>
            <div style={{ flex: 1, height: 1, background: "var(--border)", marginLeft: 12 }} />
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(min(210px, 90vw), 1fr))", gap: 16 }}>
            {usedCreators.slice(0, 4).map(c => (
              <div key={c.id} className="card fade-in" style={{ padding: 0, overflow: "hidden", cursor: "pointer", transition: "box-shadow 0.2s, transform 0.2s" }}
                onClick={onLogin}
                onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 8px 32px rgba(139,92,246,0.2)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = ""; e.currentTarget.style.transform = ""; }}>
                <div style={{ height: 80, background: c.cover, position: "relative" }}>
                  <div style={{
                    position: "absolute", bottom: -20, left: 16,
                    border: "3px solid var(--surface)", borderRadius: "50%",
                    width: 46, height: 46, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden",
                  }}>
                    <Avatar letter={c.avatarLetter} src={c.avatar} alt={c.name} size={40} />
                  </div>
                  {c.verified && (
                    <div style={{ position: "absolute", top: 8, right: 8, background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 999, padding: "4px 8px", fontSize: 10, fontWeight: 600, color: "var(--text)", display: "flex", alignItems: "center", gap: 5, boxShadow: "var(--shadow)" }}>
                      <span style={{ width: 16, height: 16, borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg,#8b5cf6,#6d28d9)", color: "#fff", flexShrink: 0 }}>
                        <Icon name="check" size={9} />
                      </span>
                      Verificado
                    </div>
                  )}
                </div>
                <div style={{ padding: "28px 16px 16px" }}>
                  <h3 className="syne" style={{ fontSize: 14, fontWeight: 700 }}>{c.name}</h3>
                  <p style={{ fontSize: 11, color: "var(--text3)", marginBottom: 10 }}>@{c.username} · {c.category}</p>
                  <div style={{ display: "flex", gap: 16, marginBottom: 14 }}>
                    <div>
                      <p className="syne" style={{ fontSize: 14, fontWeight: 700 }}>{c.posts.length}</p>
                      <p style={{ fontSize: 10, color: "var(--text3)" }}>Posts</p>
                    </div>
                    <div>
                      <p className="syne" style={{ fontSize: 14, fontWeight: 700, color: "var(--green)" }}>R${c.monthlyPrice.toFixed(0)}</p>
                      <p style={{ fontSize: 10, color: "var(--text3)" }}>/mês</p>
                    </div>
                  </div>
                  <button className="btn btn-accent" style={{ width: "100%", justifyContent: "center", fontSize: 13, padding: "8px" }}
                    onClick={e => { e.stopPropagation(); onLogin(); }}>
                    <Icon name="crown" size={13} /> Assinar
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA banner */}
        <div style={{
          padding: "36px 32px", borderRadius: "var(--r3)",
          background: "linear-gradient(135deg, rgba(139,92,246,0.14), rgba(109,40,217,0.06))",
          border: "1px solid rgba(139,92,246,0.22)", textAlign: "center",
        }}>
          <h2 className="syne" style={{ fontSize: 22, fontWeight: 800, marginBottom: 10 }}>
            Pronto para ver o conteúdo completo?
          </h2>
          <p style={{ color: "var(--text2)", marginBottom: 24, fontSize: 15 }}>
            Crie sua conta gratuitamente e assine seus criadores favoritos.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button className="btn btn-accent" style={{ padding: "12px 32px", fontSize: 15 }} onClick={onLogin}>
              <Icon name="user" size={16} /> Criar conta grátis
            </button>
            <button className="btn btn-ghost" style={{ padding: "12px 32px", fontSize: 15 }} onClick={onLogin}>
              <Icon name="arrow_right" size={16} /> Entrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [page, setPage] = useState("feed");
  const [subscriptions, setSubscriptions] = useState([]);
  const [creators, setCreators] = useState([]);
  const [routeCreatorSlug, setRouteCreatorSlug] = useState(() => getCreatorSlugFromPath(window.location.pathname));
  const [routeCreator, setRouteCreator] = useState(null);
  const [routeCreatorLoading, setRouteCreatorLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [theme, setTheme] = useState(() => localStorage.getItem("angel_theme") || "dark");
  const [toasts, setToasts] = useState([]);
  const [bootstrapping, setBootstrapping] = useState(Boolean(api.getAccessToken()) || Boolean(getCreatorSlugFromPath(window.location.pathname)));
  const [guestMode, setGuestMode] = useState(true);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("angel_theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme((t) => t === "dark" ? "light" : "dark");
  const dismissToast = (id) => setToasts((items) => items.filter((t) => t.id !== id));
  const addToast = (toast) => {
    const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    setToasts((items) => [...items, { id, type: "info", ...toast }]);
    setTimeout(() => dismissToast(id), 4500);
  };

  const hydratePublicCreators = async () => {
    const creatorProfiles = await api.creators().catch(() => []);
    const mappedCreators = creatorProfiles
      .map((creator, index) => toCreatorViewModel(creator, index))
      .filter(hasPublicUsername);

    const creatorsWithPosts = await Promise.all(
      mappedCreators.map(async (creator) => {
        const posts = await api.creatorFeed(creator.id, { withAuth: false }).catch(() => []);
        const normalizedPosts = posts.map(toPostViewModel);
        return {
          ...creator,
          posts: normalizedPosts,
          postsCount: normalizedPosts.length,
        };
      })
    );

    setCreators(buildGuestCreatorCatalog(creatorsWithPosts));
  };

  const openCreatorPage = (creator) => {
    const slug = toUnifiedSlug(creator?.username || "", "");
    if (!slug) return;
    window.history.pushState({}, "", `/${slug}`);
    setRouteCreatorSlug(slug);
  };

  const closeCreatorPage = () => {
    if (window.location.pathname !== "/") {
      window.history.pushState({}, "", "/");
    }
    setRouteCreatorSlug(null);
    setRouteCreator(null);
  };

  const navigatePage = (nextPage) => {
    closeCreatorPage();
    setPage(nextPage);
  };

  const hydrateSession = async () => {
    let profile;
    try {
      profile = await api.me();
    } catch {
      await api.updateMe({});
      profile = await api.me();
    }

    const [creatorProfiles, userSubscriptions, userNotifications] = await Promise.all([
      api.creators().catch(() => []),
      api.subscriptions().catch(() => []),
      api.notifications().catch(() => []),
    ]);

    const subscriptionIds = userSubscriptions
      .filter((s) => s.status === "active")
      .map((s) => s.creatorId);

    const mappedCreators = creatorProfiles
      .map((c, idx) => toCreatorViewModel(c, idx))
      .filter(hasPublicUsername);
    const creatorsWithPosts = await Promise.all(
      mappedCreators.map(async (creator) => {
        const posts = await api.creatorFeed(creator.id).catch(() => []);
        const normalizedPosts = posts.map(toPostViewModel);
        return {
          ...creator,
          posts: normalizedPosts,
          postsCount: normalizedPosts.length,
          subscribers: userSubscriptions.filter((s) => s.creatorId === creator.id && s.status === "active").length,
        };
      })
    );

    setCurrentUser({
      id: profile.userId || profile.id,
      name: profile.displayName || (profile.email ? profile.email.split("@")[0] : "Usuário"),
      username: profile.username ? toUnifiedSlug(profile.username, "") : "",
      email: profile.email,
      role: profile.role,
      avatar: profile.avatarUrl || null,
    });
    setCreators(creatorsWithPosts);
    setSubscriptions(subscriptionIds);
    setNotifications((userNotifications || []).map(toNotificationViewModel));
  };

  useEffect(() => {
    (async () => {
      try {
        if (api.getAccessToken()) {
          await hydrateSession();
        } else {
          await hydratePublicCreators();
        }
      } catch {
        if (api.getAccessToken()) api.clearTokens();
        setCurrentUser(null);
      } finally {
        setBootstrapping(false);
      }
    })();
  }, []);

  useEffect(() => {
    const onPopState = () => setRouteCreatorSlug(getCreatorSlugFromPath(window.location.pathname));
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  useEffect(() => {
    if (!routeCreatorSlug) {
      setRouteCreator(null);
      setRouteCreatorLoading(false);
      return;
    }

    const localCreator = creators.find((c) => hasPublicUsername(c) && c.username === routeCreatorSlug);
    if (localCreator) {
      setRouteCreator(localCreator);
      setRouteCreatorLoading(false);
      return;
    }

    let active = true;
    (async () => {
      setRouteCreatorLoading(true);
      try {
        const profile = await api.creatorByUsername(routeCreatorSlug);
        if (!profile || !active) return;

        const mapped = toCreatorViewModel(profile, 0);
        const posts = await api.creatorFeed(mapped.id, { withAuth: false }).catch(() => []);
        if (!active) return;

        setRouteCreator({
          ...mapped,
          posts: posts.map(toPostViewModel),
          postsCount: posts.length,
        });
      } catch {
        if (!active) return;
        setRouteCreator(null);
      } finally {
        if (active) setRouteCreatorLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, [routeCreatorSlug, creators, currentUser]);

  const subscribe = async (creatorId) => {
    const creator = creators.find((c) => c.id === creatorId);
    try {
      await api.createSubscription(creatorId, creator?.monthlyPrice || 19.9);
      setSubscriptions((s) => [...new Set([...s, creatorId])]);
      addToast({
        type: "success",
        title: "Assinatura ativa",
        message: `Você agora assina ${creator?.name || "este criador"}.`,
      });
      return true;
    } catch (e) {
      addToast({
        type: "error",
        title: "Assinatura não concluída",
        message: friendlyError(e, "Não foi possível concluir a assinatura."),
      });
      return false;
    }
  };

  const unsubscribe = async (creatorId) => {
    const creator = creators.find((c) => c.id === creatorId);
    try {
      await api.cancelSubscription(creatorId);
      setSubscriptions((s) => s.filter((id) => id !== creatorId));
      addToast({
        type: "success",
        title: "Assinatura cancelada",
        message: `Você não assina mais ${creator?.name || "este criador"}.`,
      });
    } catch (e) {
      addToast({
        type: "error",
        title: "Não foi possível cancelar",
        message: friendlyError(e, "Tente novamente em alguns instantes."),
      });
    }
  };

  const toggleLike = async (postId) => {
    try {
      await api.toggleLike(postId);
    } catch (e) {
      addToast({
        type: "error",
        title: "Não foi possível curtir",
        message: friendlyError(e, "Tente novamente."),
      });
    }
  };

  const addComment = async (postId, text) => {
    try {
      await api.addComment(postId, text);
      addToast({
        type: "success",
        title: "Comentário enviado",
        message: "Seu comentário foi publicado.",
      });
    } catch (e) {
      addToast({
        type: "error",
        title: "Não foi possível comentar",
        message: friendlyError(e, "Tente novamente."),
      });
    }
  };

  const markAllRead = async () => {
    try {
      await api.markAllRead();
      setNotifications((n) => n.map((notif) => ({ ...notif, read: true })));
      addToast({
        type: "success",
        title: "Notificações atualizadas",
        message: "Todas as notificações foram marcadas como lidas.",
      });
    } catch (e) {
      addToast({
        type: "error",
        title: "Não foi possível atualizar",
        message: friendlyError(e, "Tente novamente."),
      });
    }
  };

  const updateProfile = async (payload) => {
    await api.updateMe(payload);
    await hydrateSession();
  };

  const changeRole = async (newRole) => {
    await api.updateMe({ role: newRole });
    // Optimistic update + full re-hydrate to confirm backend persisted the change
    setCurrentUser(u => u ? { ...u, role: newRole } : u);
    await hydrateSession();
  };

  const logout = () => {
    api.clearTokens();
    setCurrentUser(null);
    setSubscriptions([]);
    setNotifications([]);
    hydratePublicCreators().catch(() => setCreators(buildGuestCreatorCatalog([])));
    setRouteCreatorSlug(null);
    setRouteCreator(null);
    setPage("feed");
  };

  const login = async (tokens) => {
    api.setTokens(tokens.accessToken, tokens.refreshToken);
    await hydrateSession();
  };

  if (bootstrapping) {
    return (
      <>
        <GlobalStyles />
        <Toasts toasts={toasts} onDismiss={dismissToast} />
        <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", color: "var(--text2)" }}>
          Carregando sessão...</div>
      </>
    );
  }

  if (!currentUser) {
    const themeToggleBtn = (
      <button onClick={toggleTheme} style={{
        position: "fixed", top: 20, right: 20, zIndex: 50,
        background: "var(--surface)", border: "1px solid var(--border)",
        borderRadius: "var(--r)", padding: "8px 14px",
        color: "var(--text2)", display: "flex", alignItems: "center", gap: 8,
        fontSize: 13, cursor: "pointer",
        boxShadow: "var(--shadow)",
        transition: "all 0.2s",
      }}>
        <Icon name={theme === "dark" ? "sun" : "moon"} size={16} />
        <span>{theme === "dark" ? "Claro" : "Escuro"}</span>
      </button>
    );

    if (routeCreatorSlug) {
      const guestCreator = routeCreator || creators.find((c) => hasPublicUsername(c) && c.username === routeCreatorSlug) || null;
      const goLogin = () => { closeCreatorPage(); setGuestMode(false); };
      const goExplore = () => closeCreatorPage();
      return (
        <>
          <GlobalStyles />
          <Toasts toasts={toasts} onDismiss={dismissToast} />
          <div className="layout">
            <GuestSidebar onLogin={goLogin} onExplore={goExplore} theme={theme} toggleTheme={toggleTheme} />
            <main style={{ flex: 1, overflowY: "auto", minHeight: "100vh" }}>
              <div style={{ maxWidth: 800, margin: "0 auto", padding: "32px 24px" }}>
                {routeCreatorLoading ? (
                  <div className="card" style={{ textAlign: "center", color: "var(--text2)" }}>Carregando criador...</div>
                ) : (
                  <PublicCreatorPage
                    creator={guestCreator}
                    isSubscribed={false}
                    onBack={goExplore}
                    onSubscribe={() => Promise.resolve(false)}
                    canSubscribe={false}
                    showPosts={true}
                  />
                )}
                <div className="card" style={{ marginTop: 18, textAlign: "center" }}>
                  <h3 className="syne" style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Entre para assinar e liberar conteúdo</h3>
                  <p style={{ color: "var(--text2)", marginBottom: 14 }}>Faça login para visualizar os posts completos e assinar este criador.</p>
                  <button className="btn btn-accent" onClick={goLogin}>
                    <Icon name="user" size={14} /> Entrar
                  </button>
                </div>
              </div>
            </main>
          </div>
        </>
      );
    }

    if (guestMode) return (
      <>
        <GlobalStyles />
        <Toasts toasts={toasts} onDismiss={dismissToast} />
        <LandingPage onLogin={() => setGuestMode(false)} creators={creators} theme={theme} toggleTheme={toggleTheme} />
      </>
    );

    return (
      <>
        <GlobalStyles />
        <Toasts toasts={toasts} onDismiss={dismissToast} />
        {themeToggleBtn}
        <AuthScreen onLogin={login} onToast={addToast} onGuest={() => setGuestMode(true)} />
      </>
    );
  }

  const pages = {
    feed: <FeedPage setPage={navigatePage} />,
    explore: <ExplorePage />,
    dashboard: currentUser.role === "creator" ? <DashboardPage /> : <ExplorePage />,
    subscriptions: <SubscriptionsPage />,
    profile: <ProfilePage />,
  };

  return (
    <AppContext.Provider value={{
      currentUser, creators, subscriptions, notifications,
      subscribe, unsubscribe, toggleLike, addComment, markAllRead, logout,
      theme, toggleTheme, addToast, updateProfile, changeRole,
      navigatePage,
      routedCreatorSlug: routeCreatorSlug,
      openCreatorPage,
      closeCreatorPage,
    }}>
      <GlobalStyles />
      <Toasts toasts={toasts} onDismiss={dismissToast} />
      <div className="app-shell">
        <TopBar theme={theme} toggleTheme={toggleTheme} setPage={navigatePage} />
        <main className="app-main">
          <div style={{ maxWidth: 800, margin: "0 auto", padding: "24px 20px" }}>
            {routeCreatorSlug ? (
              routeCreatorLoading ? (
                <div className="card" style={{ textAlign: "center", color: "var(--text2)" }}>Carregando criador...</div>
              ) : (
                <PublicCreatorPage
                  creator={routeCreator || creators.find((c) => hasPublicUsername(c) && c.username === routeCreatorSlug) || null}
                  isSubscribed={Boolean((routeCreator || {}).id && subscriptions.includes((routeCreator || {}).id))}
                  onBack={closeCreatorPage}
                  onSubscribe={subscribe}
                />
              )
            ) : pages[page]}
          </div>
        </main>
        <BottomNav page={page} setPage={navigatePage} />
      </div>
    </AppContext.Provider>
  );
}



